<template>
  <div style="position: relative; height: 100%; overflow: hidden">
    <div class="video-content" style="" id="full_player">
      <div
        :class="'video-canvas'"
        id="canvas_class"
        style="background-color: rgba(0, 0, 0, 0.3)"
        @mouseenter="handleMouseOver"
        @mouseleave="handleMouseLeave"
        @mousemove="handleMouseMove"
        @touchstart="handleTouch"
        @touchend="handleMouseLeave"
      >
        <!-- <i class="el-icon-arrow-left" style="width:50px;height:50px;font-size:50px;padding-top: 30%;cursor: pointer;"></i> -->
        <div
          style="position: relative; height: 100%; text-align: center"
          id="Fullscreen"
        >
          <!-- <img :src="clickUrl" style="width:100%;height:100%" /> -->
          <div
            v-if="clickUrl"
            style="
              height: 100%;
              width: 100%;
              overflow: hidden;
              display: flex;
              align-items: center;
              justify-content: center;
            "
            id="cavans_container"
          >
            <div
              v-show="isImgType(clickUrl.url)"
              style="
                height: 100%;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <img
                v-if="
                  clickUrl.url?.split('.')[
                    clickUrl.url?.split('.').length - 1
                  ] !== 'svg'
                "
                class="image_class"
                :id="'image_id'"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                  background-color: #fff;
                "
                :src="clickUrl.url"
                @animationstart="animationStart"
                @animationend="animationEnd"
              />
              <img
                v-else
                class="image_class"
                :id="'image_id'"
                style="width: 100%; height: 100%; background-color: #fff"
                :src="clickUrl.url"
                @animationstart="animationStart"
                @animationend="animationEnd"
              />
            </div>
            <div
              v-show="isVideoType(clickUrl.url)"
              style="
                height: 100%;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <video
                :src="clickUrl.url"
                id="video_class"
                webkit-playsinline="true"
                playsinline=""
                preload="auto"
                :autoplay="commandFull == 2 ? true : false"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
              ></video>
            </div>
            <div
              v-show="!isImgType(clickUrl.url) && !isVideoType(clickUrl.url)"
              style="width: 100%; height: 100%; position: absolute; z-index: 10"
              v-if="isMobile"
            ></div>
          </div>
          <div v-else style="width: 100%; height: 100%">
            <div
              style="
                height: 100%;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 32px;
                color: #fff;
              "
            >
              <!-- No Data -->
              {{ chineseWebsite ? "无数据" : "No data" }}
            </div>
          </div>
          <div class="h-full class_list" v-if="isOpenFolder">
            <div
              v-for="(item, index) in imgUrl"
              :key="index"
              :id="'drag_left_' + index"
            >
              <div
                :class="
                  index == clickIndex ? 'drag_class drag_border' : 'drag_class'
                "
              >
                <div
                  style="
                    height: 100%;
                    width: 100%;
                    background-color: #fff;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                  @click="handleClickPPT(index)"
                >
                  <img
                    v-if="isImgType(item.url)"
                    :src="item.url"
                    style="
                      width: auto;
                      height: auto;
                      max-width: 100%;
                      max-height: 100%;
                      background-color: #fff;
                    "
                  />
                  <template v-else-if="isVideoType(item.url)">
                    <img
                      v-if="isImgType(item.thumbnailImg)"
                      :src="item.thumbnailImg"
                      style="
                        width: auto;
                        height: auto;
                        max-width: 100%;
                        max-height: 100%;
                      "
                    />
                    <video
                      v-else
                      style="
                        width: auto;
                        height: auto;
                        max-width: 100%;
                        max-height: 100%;
                      "
                      :src="item.url"
                    ></video>
                  </template>
                  <div
                    v-else
                    style="
                      height: 100%;
                      width: 100%;
                      position: relative;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      background-color: #fff;
                    "
                    :id="'drag_iframe_' + index"
                  >
                    <div style="color: #409eff; font-size: 32px">
                      <i class="el-icon-link"></i>
                      <div class="hidden_text">
                        <span>{{ item.url }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- v-if="!showTitle" -->
          <div class="footer" v-if="!showTitle">
            <div @click="handleClickPre" class="icon_class icon_left_class">
              <img
                src="../assets/next_1.svg"
                width="30"
                height="30"
                style="transform: rotate(180deg)"
              />
            </div>
            <div @click="handleClickNext" class="icon_class">
              <img src="../assets/next_1.svg" width="30" height="30" />
            </div>
            <div
              class="icon_folder"
              id="folder_class"
              @click="handleFolderOpen"
              v-if="!isOpenFolder"
            >
              <img src="../assets/folder_1.svg" width="26" height="26" />
            </div>
            <div
              v-if="isOpenFolder"
              class="icon_folder"
              id="unFolder_class"
              @click="handleFolderOpen"
            >
              <img
                src="../assets/folder_1.svg"
                width="26"
                height="26"
                style="transform: rotate(180deg)"
              />
            </div>
            <div
              class="voice_class"
              style="text-align: center"
              v-if="backgroundMusic || backgroundBlog"
            >
              <el-popover
                placement="top"
                width="30"
                trigger="click"
                popper-class="pop_class"
              >
                <div
                  style="
                    width: 100%;
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <el-slider
                    v-model="bgmvolume"
                    vertical
                    height="150px"
                    class="slider_class"
                    @change="volumechange(bgmvolume)"
                  >
                  </el-slider>
                </div>
                <img
                  src="../assets/voiceOpen_1.svg"
                  slot="reference"
                  width="30"
                  height="30"
                />
              </el-popover>
            </div>
            <div
              :class="
                backgroundMusic || backgroundBlog ? 'play_mode' : 'voice_class'
              "
            >
              <el-popover
                placement="top"
                width="140"
                trigger="hover"
                popper-class="pop_class"
              >
                <div style="width: 100%">
                  <div
                    :class="commandFull === 1 ? 'auto_class' : 'tool_class'"
                    style="
                      font-size: 14px;
                      margin-bottom: 10px;
                      width: 100%;
                      text-align: center;
                      cursor: pointer;
                    "
                    @click="handleClickFull(1)"
                  >
                    {{ chineseWebsite ? "自动播放" : "Auto play" }}
                  </div>
                  <div
                    :class="commandFull === 2 ? 'auto_class' : 'tool_class'"
                    style="
                      font-size: 14px;
                      cursor: pointer;
                      width: 100%;
                      text-align: center;
                    "
                    @click="handleClickFull(2)"
                  >
                    {{
                      chineseWebsite ? "根据音频播放" : "Auto play with audio"
                    }}
                  </div>
                </div>
                <el-button
                  type="text"
                  style="color: #fff; font-size: 14px; width: 5vh"
                  slot="reference"
                  >{{ chineseWebsite ? "播放模式" : "Play mode" }}</el-button
                >
              </el-popover>
            </div>
            <div class="language_class">
              <el-popover
                placement="top"
                width="100"
                trigger="hover"
                popper-class="pop_class"
              >
                <div style="width: 100px">
                  <div
                    v-for="(item, index) in languageConfig"
                    :key="index"
                    @click="handleChangeLanguage(item)"
                    style="
                      font-size: 14px;
                      width: 100%;
                      text-align: center;
                      cursor: pointer;
                      color: #fff;
                    "
                    :class="
                      item.language === languageSelect ? 'auto_class' : ''
                    "
                  >
                    {{
                      item.language === "Chinese" && chineseWebsite
                        ? "中文"
                        : item.language
                    }}
                  </div>
                </div>
                <el-button
                  v-if="languageShow"
                  type="text"
                  style="color: #fff; font-size: 14px"
                  slot="reference"
                  >{{ chineseWebsite ? "语言" : "Language" }}</el-button
                >
              </el-popover>
            </div>
            <div
              style="
                font-size: 26px;
                width: 26px;
                height: 26px;
                color: #fff;
                cursor: pointer;
              "
              class="setting_class"
            >
              <el-popover
                placement="top-end"
                width="180"
                trigger="click"
                popper-class="pop_class"
                offset="10"
              >
                <div style="width: 180px">
                  <div style="font-size: 14px">
                    <div
                      style="
                        margin-bottom: 30px;
                        display: flex;
                        margin-top: 10px;
                      "
                    >
                      <div>
                        <img
                          src="../assets/play_icon1.svg"
                          width="20"
                          height="20"
                        />
                      </div>
                      <div style="margin-left: 8px; color: #fff">
                        {{ chineseWebsite ? "播放速度" : "Speed" }}
                      </div>
                      <div style="position: absolute; right: 0; color: #999999">
                        <el-popover
                          placement="right-start"
                          trigger="hover"
                          width="80"
                          popper-class="pop_class"
                        >
                          <div
                            style="
                              width: 100%;
                              font-size: 14px;
                              color: #fff;
                              text-align: left;
                            "
                          >
                            <div
                              class="menuitem-hover text-white pl-3 pr-3"
                              v-for="(item, index) in speedList"
                              :key="index"
                              style="margin-bottom: 10px; cursor: pointer"
                              @click="rangechange(item)"
                            >
                              <i
                                style="width: 20px"
                                v-if="rangevalSelect == item.label"
                                class="el-icon-check"
                              ></i>
                              <span
                                :style="
                                  rangevalSelect == item.label
                                    ? ''
                                    : 'margin-left:20px'
                                "
                              >
                                {{ item.label }}</span
                              >
                            </div>
                          </div>
                          <div style="cursor: pointer" slot="reference">
                            {{
                              speed == 1
                                ? chineseWebsite
                                  ? "正常"
                                  : "Normal"
                                : rangevalSelect
                            }}
                            <i class="el-icon-arrow-right"></i>
                          </div>
                        </el-popover>
                      </div>
                    </div>
                    <div
                      style="
                        margin-bottom: 30px;
                        display: flex;
                        width: 100%;
                        position: relative;
                      "
                    >
                      <div>
                        <img
                          src="../assets/caption_1.svg"
                          width="20"
                          height="20"
                        />
                      </div>
                      <div style="margin-left: 8px; color: #fff">
                        {{ chineseWebsite ? "字幕" : "Caption" }}
                      </div>
                      <div style="position: absolute; right: 0">
                        <el-switch v-model="captionAll"> </el-switch>
                      </div>
                    </div>
                    <div style="display: flex">
                      <div>
                        <img
                          src="../assets/animation_1.svg"
                          width="20"
                          height="20"
                        />
                      </div>
                      <div style="margin-left: 8px; color: #fff">
                        {{ chineseWebsite ? "动画" : "Animation" }}
                      </div>
                      <div style="position: absolute; right: 0; color: #999999">
                        <el-popover
                          placement="right-start"
                          trigger="hover"
                          width="150"
                          popper-class="pop_class"
                        >
                          <div
                            style="width: 100%; font-size: 14px; color: #fff"
                          >
                            <div
                              v-for="item in animationOption"
                              class="menuitem-hover w-full"
                              :key="item.value"
                              style="
                                margin-bottom: 20px;
                                cursor: pointer;
                                white-space: normal;
                                word-break: break-word;
                                text-align: left;
                              "
                              @click="handleAnimation(item)"
                            >
                              <i
                                class="el-icon-check"
                                v-if="animationCheckedLabel === item.label"
                              ></i>
                              <span
                                :style="
                                  animationCheckedLabel === item.label
                                    ? ''
                                    : 'margin-left:20px'
                                "
                              >
                                {{ item.label }}</span
                              >
                            </div>
                          </div>
                          <div
                            style="cursor: pointer; display: flex"
                            slot="reference"
                          >
                            <div
                              style="
                                width: 70px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                text-align: right;
                              "
                            >
                              {{ animationCheckedLabel }}
                            </div>
                            <div><i class="el-icon-arrow-right"></i></div>
                          </div>
                        </el-popover>
                      </div>
                    </div>
                  </div>
                </div>
                <img
                  src="../assets/setting_1.svg"
                  slot="reference"
                  width="26"
                  height="26"
                />
              </el-popover>
            </div>
            <div
              style="
                font-size: 26px;
                width: 26px;
                height: 26px;
                color: #fff;
                cursor: pointer;
              "
              class="fullscreen_class"
              @click="handleFullScreen"
            >
              <img src="../assets/fullscreen_1.svg" width="26" height="26" />
            </div>
          </div>

          <div
            class="free"
            @click="handelSignup"
            v-if="!showTitle && playMode !== 'chat'"
          >
            {{ chineseWebsite ? "免费使用" : "Free trial" }}
          </div>
          <div class="video-title" v-if="!isFirst && title">
            <span
              style="
                margin: 0 15px 0 15px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
              "
              >{{ title }}</span
            >
          </div>
          <div
            class="play_icon_text"
            v-if="isMouseOver === true"
            @click="handleClickPlay"
          >
            <img v-if="isPlay === true && isFirst === true" :src="pausepause" />
            <img v-else :src="playplay" />
          </div>
          <div
            v-if="
              speechText.length > 0 &&
              speechText[speechIndex]?.trim().length > 0 &&
              caption === true &&
              commandFull === 2 &&
              isPlay === true &&
              captionAll === true
            "
            class="close_caption"
          >
            {{ speechText[speechIndex] }}
          </div>
        </div>
      </div>
    </div>
    <button
      id="blogAutoPlayPPT"
      style="display: none"
      @click="handleClickFull(2)"
    ></button>
    <PresentationEnd
      :showEndData="showEndData"
      @closeEndData="closeEndData"
      @closeTimerToShowEndData="closeTimerToShowEndData"
      @sharePPT="sharePPT"
      @reloadPPT="reloadPPT"
    ></PresentationEnd>
  </div>
</template>
<script>
import { $postHttp, $getViewInfo } from "../utils/request";
import {
  getPresentationBlogByPlayer,
  getSharePresentationDetails,
  updatePresentationStatistics,
  getPresentationBlog,
  createPlayDetailRecord,
  updatePlayDetailRecord,
  getIssue,
} from "../graphql/presentation";
import { apiUrl } from "../utils/global";
import { cI18n } from "../utils/cI18n";
import PresentationEnd from "./presentation/PresentationEnd.vue";
import playplay from "../assets/playplay.svg";
import pausepause from "../assets/pausepause.svg";
export default {
  name: "playerPage",
  components: {
    PresentationEnd,
  },
  data() {
    return {
      playplay,
      pausepause,
      UrlTemp: "",
      imgUrl: [],
      clickUrl: {},
      clickIndex: 0,
      imgType: [
        "jpg",
        "JPG",
        "PNG",
        "png",
        "jpeg",
        "JPNG",
        "BMP",
        "bmp",
        "svg",
        "gif",
        "webp",
        "WEBP",
        "JPEG",
      ],
      isPlay: true,
      showTitle: true,
      rightIconClass: "icon_class right_icon",
      leftIconClass: "icon_disable left_icon",
      command: 0,
      selectVoices: "en-US-AriaNeural",
      selectLang: "en-US",
      intervalTest: "",
      isOpenFolder: false,
      timeout: "",
      commandFull: 0,
      speechText: [],
      speechIndex: 0,
      caption: true,
      defaultImgUrl: [],
      isDefault: false,
      isFirst: false,
      currentTTSText: [-1, 0],
      currentTTSIndex: 0,
      visible: false,
      languageMain: "English",
      presentationId: "",
      languageSelect: "English",
      languageConfig: [],
      playMode: "base",
      presentationData: [],
      isStarting: false,
      isStartPlaying: false,
      isGetBlogScrollData: false,
      speed: "1",
      rangeval: ((1 * 10) / 10).toFixed(2),
      rate: "10",
      bgmvolume: 10,
      backgroundMusic: "",
      bgmaudio: "",
      isFull: true,
      isMouseOver: true,
      mouseTimeOut: "",
      isClick: false,
      isClickPlay: false,
      isFullRotate: false,
      blogData: [],
      id: 0,
      pdrId: 0,
      pdrIndex: 0,
      isFirstAuto: false,
      backgroundBlog: "",
      backgroundBlogVolume: 10,
      isMobile: false,
      loadingIntance: null,
      isSpeak: false,
      // saasTemp: null,
      scriptAudiourl: "",
      blogContentMode: "",
      animationTimeOut: "",
      animation: null,
      animationList: [
        "imgZoomin",
        "imgZoominandOut",
        "imgScanLeft",
        "imgScanRight",
      ],
      animationIndex: 0,
      animationOption: [],
      animationChecked: "",
      animationCheckedLabel: "None",
      time: null,
      chineseWebsite: false,
      currentTTSVideoText: [-1, 0],
      currentTTSVideoIndex: 0,
      videoScriptStart: 0,
      blogBrief: false,
      shortAudioScript: "",
      /* end info */
      //存放当前的ppt中各种状态是否结束，重开一页后重置
      endConfig: {
        //默认为false，表示没结束，需要和实际情况结合，当前ppt可能不包含所有情况
        video: false,
        script: false,
        audio: false,
        animate: false,
      },
      showEndData: false,
      endTimer: null,
      shareUUID: "",
      languageShow: true,
      audioScript: "",
      callToActionEnable: 2,
      captionAll: true,
      rangevalSelect: "",
      speedList: [],
      title: "",
      autoPlaySlide: 5,
    };
  },
  methods: {
    rangechange(speedText) {
      this.speed = speedText.value;
      this.rangevalSelect = speedText.label;
      this.rangeval = ((this.speed * 10) / 10).toFixed(2);
      this.rate = this.rangeval * 10;
      this.imgUrl.forEach((item) => {
        item.buffers = new Array(item.scripts?.length);
      });
      this.currentTTSText = [-1, 0];
      this.currentTTSIndex = 0;
      //console.log(this.rangeval);
    },
    handelOriginalvideo() {
      //console.log("paramsObj", this.shareUUID);
      if (location.origin === "http://localhost:8089") {
        let originalVideoUrl = "http://localhost:8089/?s=" + this.shareUUID;
        window.open(originalVideoUrl, "_back");
      } else {
        let originalVideoUrl =
          location.origin + "/sharepresentation/?s=" + this.shareUUID;
        window.open(originalVideoUrl, "_back");
      }
    },
    handelOriginalbrief() {
      //console.log("paramsObj", this.shareUUID);
      if (location.origin === "http://localhost:8089") {
        // http://localhost:8089/?s=blog&i=2509
        let originalVideoUrl =
          "http://localhost:8089/?s=blog&i=" + this.blogData.id;
        window.open(originalVideoUrl, "_back");
      } else {
        let originalVideoUrl =
          location.origin + "/sharepresentation/?s=blog&i=" + this.blogData.id;
        window.open(originalVideoUrl, "_back");
      }
    },
    handelSignup() {
      // let Id = window.location.search.split("=")[1];
      if (
        location.origin === "http://localhost:8089" ||
        location.origin === "https://sf.easiio.cn" ||
        location.origin === "https://easiio.sflow.io"
      ) {
        this.UrlTemp = "https://sflow.io/register/?signup=";
      }
      if (
        location.origin.includes("sflow.pro") ||
        location.origin.includes("saasflow.cn")
      ) {
        this.UrlTemp = "https://id.saasflow.cn/#/login?signup=";
      }
      window.open(this.UrlTemp + this.shareUUID, "_back");
    },
    handleSetInterval(time) {
      //this.isPlay = true;
      //this.commandFull = 1;
      let handleTime = "";
      if (this.isVideoType(this.clickUrl.url)) {
        let domVideo = document.getElementById("video_class");
        this.command = 1;
        // domVideo.addEventListener("canplay", this.handleAutoNext);
        this.intervalTest = setTimeout(() => {
          this.clickIndex = (this.clickIndex + 1) % this.imgUrl.length;
          this.clickUrl = this.imgUrl[this.clickIndex];
          this.handleSetInterval(this.autoPlaySlide * 1000);
        }, time);
        return;
      } else {
        this.intervalTest = setTimeout(() => {
          this.clickIndex = (this.clickIndex + 1) % this.imgUrl.length;
          this.clickUrl = this.imgUrl[this.clickIndex];
          // console.log("this.clickIndex", this.clickIndex);
          // console.log("this.clickUrl", this.clickUrl);
          this.handleSetInterval(this.autoPlaySlide * 1000);
        }, time);
      }
    },
    async init(presentationId) {
      try {
        if (this.loadingIntance && this.loadingIntance.close) {
          this.loadingIntance.close();
        }
        this.speedList = [
          {
            label: "0.5x",
            value: "0.50",
          },
          {
            label: "0.75x",
            value: "0.75",
          },
          {
            label: this.chineseWebsite ? "正常" : "Normal",
            value: "1.00",
          },
          {
            label: "1.25x",
            value: "1.25",
          },
          {
            label: "1.5x",
            value: "1.50",
          },
          {
            label: "1.75x",
            value: "1.75",
          },
          {
            label: "2x",
            value: "2.00",
          },
          {
            label: "2.25x",
            value: "2.25",
          },
          {
            label: "2.5x",
            value: "2.50",
          },
          {
            label: "3x",
            value: "3.00",
          },
        ];
        this.animationOption = [
          {
            label: this.chineseWebsite ? "无" : "None",
            value: "",
          },
          {
            label: this.chineseWebsite ? "放大" : "Zoom in",
            value: "imgZoomin",
          },
          {
            label: this.chineseWebsite ? "放大再缩小" : "Zoom in and out",
            value: "imgZoominandOut",
          },
          {
            label: this.chineseWebsite ? "从左扫描" : "Scan from left",
            value: "imgScanLeft",
          },
          {
            label: this.chineseWebsite ? "从右扫描" : "Scan from right",
            value: "imgScanRight",
          },
          {
            label: this.chineseWebsite ? "从上扫描" : "Scroll down",
            value: "imgScrolldown",
          },
          {
            label: this.chineseWebsite
              ? "从上扫描再返回"
              : "Scroll down and up",
            value: "imgScrolldownUp",
          },
          {
            label: this.chineseWebsite ? "随机" : "Random",
            value: "imgRandom" || null,
          },
        ];
        this.animationCheckedLabel = this.chineseWebsite ? "无" : "None";
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          this.isMobile = true;
        }
        if (this.playMode === "base") {
          // let domRight = document.getElementsByClassName('icon_action')
          // console.log("domRight",domRight);
          // domRight[0].style.display = 'block'
          const res = await $postHttp(`${apiUrl}/graphql`, {
            data: {
              query: getSharePresentationDetails,
              variables: {
                shareUUID: presentationId,
              },
            },
          });
          if (res.errors && res.errors.length) {
            throw new Error(res.errors[0].message);
          }
          //console.log("res", res);
          //console.log("presentationId", presentationId);
          this.presentationId =
            res.data.getSharePresentationDetails[0].presentationId;
          this.$bus.$emit("getPresentation", this.presentationId, res);
          // this.createPDR(this.presentationId, window.location.href, 1);
          this.backgroundMusic =
            res.data.getSharePresentationDetails[0].presentation.backgroundMusic;
          // console.log(
          //   "this.backgroundMusic****************",
          //   this.backgroundMusic
          // );
          this.title =
            res.data.getSharePresentationDetails[0].presentation.name;
          this.bgmvolume =
            res.data.getSharePresentationDetails[0].presentation.backgroundVolume;
          // console.log("bgm:", this.bgmvolume);
          if (res.data.getSharePresentationDetails[0].presentation) {
            this.autoPlaySlide = res.data.getSharePresentationDetails[0]
              .presentation.autoPlaySlideInterval
              ? res.data.getSharePresentationDetails[0].presentation
                  .autoPlaySlideInterval
              : 5;
            let title = "sflow.io";
            let originStrArr = window.origin.split(".");
            if (
              ["io", "cn", "pro"].includes(
                originStrArr[originStrArr.length - 1]
              ) &&
              !window.origin.includes("easiio.cn")
            ) {
              title = `${originStrArr[originStrArr.length - 2]}.${
                originStrArr[originStrArr.length - 1]
              }`;
            }
            document.title = `${title}-${res.data.getSharePresentationDetails[0].presentation.name}`;
            const keywords =
              res.data.getSharePresentationDetails[0].presentation.keywords;
            if (keywords) {
              // 创建一个新的meta标签
              var keywordsTag = document.createElement("meta");
              keywordsTag.name = "keywords";
              keywordsTag.content =
                "AI video generator, free AI video generator, video presentation, video presentation maker, blog video maker, blog video, video blog, video marketing software, video email marketing software,PowerPoint to video, ppt to video,Video presentation, Easiio video presentation, " +
                keywords;

              // 获取head元素
              var head = document.getElementsByTagName("head")[0];

              // 添加meta标签到head中
              head.appendChild(keywordsTag);
            }
          }
          const isFresh = sessionStorage.getItem("isFresh");
          //console.log(isFresh);
          if (!isFresh) {
            sessionStorage.setItem("isFresh", true);
            const resStatistics = await $postHttp(`${apiUrl}/graphql`, {
              data: {
                query: updatePresentationStatistics,
                variables: {
                  presentationId: this.presentationId,
                  type: "impression",
                },
              },
            });
          }
          if (res.errors && res.errors.length) {
            throw new Error(res.errors[0].message);
          }
          this.imgUrl = res.data.getSharePresentationDetails;
        } else if (this.playMode === "short") {
          this.languageShow = false;
          this.blogBrief = true;
          //console.log("短视频数据");
          const res = await $postHttp(`${apiUrl}/graphql`, {
            data: {
              query: getSharePresentationDetails,
              variables: {
                shareUUID: presentationId,
              },
            },
          });
          if (res.errors && res.errors.length) {
            throw new Error(res.errors[0].message);
          }
          //console.log("res", res);
          //console.log("presentationId", presentationId);
          this.presentationId =
            res.data.getSharePresentationDetails[0].presentationId;
          this.title =
            res.data.getSharePresentationDetails[0].presentation.name;
          // this.createPDR(this.presentationId, window.location.href, 1);
          this.backgroundMusic =
            res.data.getSharePresentationDetails[0].presentation.backgroundMusic;
          //console.log(this.backgroundMusic);
          this.bgmvolume =
            res.data.getSharePresentationDetails[0].presentation.backgroundVolume;
          // console.log("bgm:", this.bgmvolume);
          this.$bus.$emit("getPresentation", this.presentationId, res);
          if (res.data.getSharePresentationDetails[0].presentation) {
            let title = "sflow.io";
            let originStrArr = window.origin.split(".");
            if (
              ["io", "cn", "pro"].includes(
                originStrArr[originStrArr.length - 1]
              ) &&
              !window.origin.includes("easiio.cn")
            ) {
              title = `${originStrArr[originStrArr.length - 2]}.${
                originStrArr[originStrArr.length - 1]
              }`;
            }
            document.title = `${title}-${res.data.getSharePresentationDetails[0].presentation.name}`;
            const keywords =
              res.data.getSharePresentationDetails[0].presentation.keywords;
            if (keywords) {
              // 创建一个新的meta标签
              var keywordsTag = document.createElement("meta");
              keywordsTag.name = "keywords";
              keywordsTag.content =
                "AI video generator, free AI video generator, video presentation, video presentation maker, blog video maker, blog video, video blog, video marketing software, video email marketing software,PowerPoint to video, ppt to video,Video presentation, Easiio video presentation, " +
                keywords;

              // 获取head元素
              var head = document.getElementsByTagName("head")[0];

              // 添加meta标签到head中
              head.appendChild(keywordsTag);
            }
          }
          // const isFresh = sessionStorage.getItem('isFresh')
          // console.log(isFresh)
          // if (!isFresh) {
          //   sessionStorage.setItem('isFresh', true)
          //   const resStatistics = await $postHttp(`${apiUrl}/graphql`, {
          //     data: {
          //       query: updatePresentationStatistics,
          //       variables: {
          //         presentationId: this.presentationId,
          //         type: 'impression',
          //       },
          //     },
          //   })
          // }
          // if (res.errors && res.errors.length) {
          //   throw new Error(res.errors[0].message)
          // }
          this.imgUrl = res.data.getSharePresentationDetails;
          // console.log(
          //   "res.data.getSharePresentationDetails",
          //   res.data.getSharePresentationDetails
          // );
          if (
            this.imgUrl[0].presentation.blogBrief &&
            this.imgUrl[0].presentation.blogBrief !== ""
          ) {
            for (const v of this.imgUrl) {
              let texts = this.imgUrl[0].presentation.blogBrief;
              // console.log("texts-----------------------------",texts);
              let elText = document.createElement("div");
              elText.innerHTML = texts;
              // console.log("elText",elText);
              let text = document.getElementsByTagName("p");
              // console.log("elText.children**********************",elText.children);
              let imgList = [];
              imgList.length = 0;
              for (const child of elText.children) {
                // console.log("child", child.tagName);
                if (child.tagName == "P") {
                  let text = child.innerText;
                  let texta = text
                    .replaceAll('{\n    "output": "', "")
                    .replaceAll('" \n}', "");
                  v.briefText = texta;
                }
                if (child.tagName == "FIGURE") {
                  let imgDom = child.innerHTML;
                  // console.log(" 图片imgDom", imgDom);
                  const RegEx = /(?<=(img src="))[^"]*?(?=")/gims;
                  let pictureUrl = imgDom.match(RegEx);
                  // console.log("pictureUrlList", pictureUrl)
                  let imgurlList = pictureUrl.toString();
                  imgList.push({ shorturl: imgurlList });
                }
                v.blogbriefImg = imgList;
              }
            }
            let imgurlList = [];
            this.shortAudioScript = this.imgUrl[0].briefText;
            //console.log(" this.shortAudioScript", this.shortAudioScript);
            this.imgUrl[0].blogbriefImg.filter((item) => {
              imgurlList.push({
                url: item.shorturl,
                animation: this.imgUrl[0].presentation.blogBriefAnimation,
                cycleanimation: 1,
                presentation: this.imgUrl[0].presentation,
              });
            });
            this.imgUrl = imgurlList;
            let reg = new RegExp("[\\u4E00-\\u9FFF]");
            if (reg.test(this.shortAudioScript)) {
              this.imgUrl.scripts =
                this.shortAudioScript.trim().split(/[。？！]/) || [];
              this.selectVoices = "zh-CN-YunyangNeural";
              // console.log(
              //   "this.imgUrl.scripts中文-----------------",
              //   this.imgUrl.scripts
              // );
            } else {
              this.imgUrl.scripts =
                this.shortAudioScript.trim().split(/[.?!]\s+/) || [];
              this.selectVoices = "en-US-AriaNeural";
              // console.log(
              //   "this.imgUrl.scripts其他-----------------",
              //   this.imgUrl.scripts
              // );
            }
            this.imgUrl.buffers = [];
            //console.log("this.imgUrl-----------------", this.imgUrl);
          }
        } else if (this.playMode === "issue") {
          this.imgUrl = this.presentationData;
        } else if (this.playMode === "brief") {
          this.languageShow = false;
          this.blogBrief = true;
          this.imgUrl = this.blogData.blogbriefContent;
          this.imgUrl.scripts = this.blogData.scripts;
          this.imgUrl.buffers = [];
          document.title = document.title + "-" + this.blogData.blogTitle;
          this.title = this.blogData.blogTitle;
        } else if (this.playMode === "blog") {
          // this.imgUrl = this.blogData.presentationBlogContent;
          //console.log("this.blogData99999", this.blogData);
          if (
            this.blogData &&
            this.blogData.presentationBlogContent &&
            this.blogData.presentationBlogContent.length ===
              this.presentationData.length
            // &&this.saasTemp != "saasflow.cn"
          ) {
            this.imgUrl = this.blogData.presentationBlogContent.map(
              (item, index) => {
                let url = item.img;
                let name = "name" + index;
                if (!item.img) {
                  if (
                    item.url &&
                    ["3gp", "rmvb", "avi", "mp4", "mov", "webm"].includes(
                      item.url.split(".")[item.url.split(".").length - 1]
                    )
                  ) {
                    name = "video" + index;
                    url = item.url;
                  } else {
                    const matchUrl =
                      item.speakTest?.match(/https?:\/\/[^\s]+/g);
                    if (matchUrl && matchUrl[0]) {
                      url = matchUrl[0];
                      name = "url";
                    } else {
                      url = item.url;
                      name = "url";
                    }
                    url = item.url;
                    if (url.includes("?")) {
                      url += "&ppt=no";
                    } else {
                      url += "?ppt=no";
                    }
                  }
                } else {
                  const re =
                    /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
                  const isUrl = item.img.match(/https?:\/\/[^\s]+/g);
                  if (!(isUrl && isUrl[0])) {
                    const reg2 =
                      /((https|http|ftp|file):\/\/)([A-Za-z0-9\-.]+)(:[0-9]+){0,1}/g;
                    const arr = item.url.match(reg2);
                    if (arr && arr[0]) {
                      url = arr[0] + item.img;
                    }
                  }
                }
                return {
                  id: index + 1,
                  name: name,
                  description: null,
                  // "presentationId": 47,
                  url: url,
                  page: index + 1,
                  script: item.speakTest
                    ? item.speakTest
                        .replaceAll("<", "")
                        .replaceAll(">", "")
                        .replaceAll("&", "and")
                        .replaceAll(/[\^@#*]/gi, "")
                    : "",
                  language: "English",
                  offsetTop: item.offsetTop,
                  animation: item.animation,
                  cycleanimation: item.cycleanimation,
                  tagIndex: item.tagIndex,
                };
              }
            );
          }
          // else if ((this.saasTemp = "saasflow.cn")) {
          //   this.imgUrl = this.presentationData;
          //   console.log("中文");
          // }
          else {
            this.imgUrl = this.presentationData;
          }
        }

        this.imgUrl.filter((item) => {
          this.defaultImgUrl.push({ url: "" });
        });
        this.imgUrl.sort((a, b) => {
          return a.page - b.page;
        });
        this.imgUrl.forEach((item) => {
          item.speakTest = item.script;
          if (this.isVideoType(item.url)) {
            this.canvasVideoThumbnail(item);
          }
        });

        this.clickUrl = this.imgUrl[0];
        this.animationChecked =
          this.clickUrl && this.clickUrl.animation !== null
            ? this.clickUrl.animation
            : "";
        if (this.playMode === "blog") {
          this.animationChecked =
            this.clickUrl && this.clickUrl.animation !== null
              ? this.clickUrl.animation
              : "imgRandom";
        }
        this.animationOption.filter((item) => {
          if (item.value == this.animationChecked)
            this.animationCheckedLabel = item.label;
        });
        // console.log(navigator);
        const browserLanguage = navigator.language;
        if (this.defaultImgUrl[0]) {
          this.defaultImgUrl[0].url = this.clickUrl?.url;
        }
        this.clickIndex = 0;
        let index = 0;
        this.rangevalSelect = this.chineseWebsite ? "正常" : "Normal";
        if (this.imgUrl.length > 0) {
          if (this.playMode === "base" || this.playMode === "short") {
            const { languageConfig } = this.imgUrl[0].presentation;
            this.callToActionEnable =
              this.imgUrl[0].presentation.callToActionEnable;
            if (languageConfig) {
              const language = JSON.parse(languageConfig);
              this.languageMain = language.main;
              //console.log(language, language.config);
              this.languageConfig = language.config;
              this.speed = this.languageConfig[0].speed;
              this.rangeval = this.languageConfig[0].rangeval;
              this.rate = this.speed ? this.speed * 10 : "10";
              //console.log("rate1", this.rate, this.languageConfig);
              // console.log(
              //   "this.languageConfig---------- ",
              //   this.languageConfig
              // );
              this.languageConfig.forEach((item) => {
                if (item.voice.includes(browserLanguage)) {
                  this.languageMain = item.language;
                  this.speed = item.speed;
                  this.rangeval = item.rangeval;
                  this.rate = this.speed ? this.speed * 10 : "10";
                }
                this.speedList.filter((item) => {
                  if (item.value == ((this.speed * 10) / 10).toFixed(2)) {
                    this.rangevalSelect = item.label;
                  }
                });
                if (!item.hasOwnProperty("speed")) {
                  for (var i = 0; i < this.languageConfig.length; i++) {
                    this.languageConfig[i].speed = ((1 * 10) / 10).toFixed(2);
                    this.languageConfig[i].rangeval = ((1 * 10) / 10).toFixed(
                      2
                    );
                  }
                  //console.log("this.languageConfig", this.languageConfig);
                }
              });
              this.languageSelect = this.languageMain;
              this.initSpeech();
            } else {
              this.languageMain = this.imgUrl[0].language;
              this.languageSelect = this.languageMain;
              this.selectVoices =
                this.imgUrl[0].language == "zh-CN" ||
                this.imgUrl[0].language == "Chinese"
                  ? "zh-CN-YunyangNeural"
                  : "en-US-AriaNeural";
            }
          }
          this.imgUrl.filter((item, index) => {
            if (!this.isVideoType(item.url) && !this.isImgType(item.url)) {
              this.createIframe(item);
              if (index === this.clickIndex) {
                let iframeClass =
                  document.getElementsByClassName("iframe_class");
                if (iframeClass) {
                  for (let iframe of iframeClass) {
                    if (
                      iframe.src == item.url ||
                      iframe.src.slice(0, iframe.src.length - 1) == item.url
                    ) {
                      iframe.style.visibility = "visible";
                    }
                  }
                }
              }
            }
          });
          //this.handleClickFull(1);
        } else {
          this.isPlay = false;
        }
      } catch (error) {
        this.$message({
          message: error.message,
          type: "error",
        });
      }
    },
    canvasVideoThumbnail(row) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const url = row.url;
      const videoEle = document.createElement("video");
      videoEle.setAttribute("crossOrigin", "Anonymous"); // 处理跨域
      videoEle.setAttribute("preload", "auto"); // auto|metadata|none
      videoEle.src = url;
      videoEle.addEventListener("loadeddata", async function () {
        try {
          canvas.width = videoEle.videoWidth;
          canvas.height = videoEle.videoHeight;
          ctx.drawImage(videoEle, 0, 0, canvas.width, canvas.height);
          const dataURL = canvas.toDataURL("image/png");
          row.thumbnailImg = dataURL;
        } catch (error) {}
      });
    },
    createPDR(presentationId, url, entityType) {
      $getViewInfo().then(async (res) => {
        const playDetailRecord = {
          url: url,
          ip: res.ip,
          location: res.country_name + "," + res.city,
          device: this.isMobile ? "Mobile" : "PC",
          browser: navigator.userAgent,
          entityType: entityType,
          entityId: Number(presentationId),
          sessionId: "",
          pages: this.imgUrl.length,
        };

        const result = await $postHttp(`${apiUrl}/graphql`, {
          data: {
            query: createPlayDetailRecord,
            variables: {
              playDetailRecord: playDetailRecord,
            },
          },
        });
        //console.log("111111111111create", result);
        if (result) {
          this.pdrId = result.data.createPlayDetailRecord.id;
        }
      });
    },
    async updatePDR(slideNo) {
      if (slideNo <= this.pdrIndex) return;
      this.pdrIndex = slideNo;
      const playDetailRecord = {
        progress: slideNo,
      };
      if (this.pdrId != 0) {
        const result = await $postHttp(`${apiUrl}/graphql`, {
          data: {
            query: updatePlayDetailRecord,
            variables: {
              id: this.pdrId,
              playDetailRecord: playDetailRecord,
            },
          },
        });
        //console.log("111111111111updatecdr", result);
      }
    },
    createIframe(item) {
      let iframeClass = document.getElementsByClassName("iframe_class");
      let exist = false;
      if (this.isImgType(item.url) || this.isVideoType(item.url)) {
        exist = true;
      }
      if (iframeClass) {
        for (let iframe of iframeClass) {
          if (
            iframe.src == item.url ||
            iframe.src.slice(0, iframe.src.length - 1) == item.url
          ) {
            exist = true;
            break;
          }
        }
      }
      if (exist === false) {
        let domIframe = document.createElement("iframe");
        domIframe.src = item.url;
        domIframe.id = "iframe_" + item.id;
        domIframe.setAttribute("class", "iframe_class");
        domIframe.width = "98%";
        domIframe.height = "100%";
        domIframe.style.visibility = "hidden";
        domIframe.style.position = "absolute";
        domIframe.onload = () => {
          this.postGetBlogScrollData(domIframe);
          this.postIframeScrollMsg(domIframe, item.offsetTop, item.speakTest);
        };
        let domCanvas = document.getElementById("cavans_container");
        domCanvas?.appendChild(domIframe);
      }
    },
    watchBlogData() {
      console.log("[watchBlogData]");
      window.addEventListener("message", async (event) => {
        //console.log("event: ", event);
        try {
          if (event.data.type === "blog-presentation-data") {
            if (this.isStarting && this.playMode !== "blog") return;
            if (event.data.data.length === 0) {
              return;
            }
            //console.log("message: ", event.data);
            const pData = JSON.parse(event.data.data);
            if (!(Array.isArray(pData) && pData.length)) {
              return;
            }
            //console.log("pData", pData);
            //console.log(location.origin);
            // if (
            //   location.origin === "https://easiio.saasflow.cn" ||
            //   location.origin === "https://saasflow.cn"
            // ) {
            //   this.languageSelect = "Chinese";
            //   this.selectVoices = "zh-CN-XiaoxiaoNeural";
            // } else {
            //   this.languageSelect = "English";
            // }
            const res = pData.map((item, index) => {
              let url = item.img;
              let name = "name" + index;
              if (!item.img) {
                if (item.url && this.isVideoType(item.url)) {
                  name = "video" + index;
                  url = item.url;
                } else {
                  const matchUrl = item.text.match(/https?:\/\/[^\s]+/g);
                  if (matchUrl && matchUrl[0]) {
                    // url = matchUrl[0];
                    name = "url";
                  } else {
                    url = item.url;
                    name = "url";
                  }
                  url = item.url;
                  if (url.includes("?")) {
                    url += "&ppt=no";
                  } else {
                    url += "?ppt=no";
                  }
                }
              }
              return {
                id: index + 1,
                name: name,
                description: null,
                // "presentationId": 47,
                url: url,
                page: index + 1,
                script: item.text
                  ? item.text
                      .replaceAll("<", "")
                      .replaceAll(">", "")
                      .replaceAll("&", "and")
                      .replaceAll(/[\^@#*]/gi, "")
                  : "",
                language: "English",
                offsetTop: item.offsetTop,
                animation: item.animation,
                cycleanimation: item.cycleanimation,
                tagIndex: item.tagIndex,
              };
            });
            this.isStarting = true;
            this.presentationData = [...res];
            //console.log("presentationData", this.presentationData);
            if (event.data.url && this.blogContentMode !== "local") {
              const urlStrs = event.data.url.split("/");
              //console.log("urlStrs[2]", urlStrs[2]);
              if (urlStrs[2]) {
                const originUrl = urlStrs[2];
                // this.saasTemp = urlStrs[2];
                if (originUrl == "saasflow.cn") {
                  this.languageSelect = "Chinese";
                  this.selectVoices = "zh-CN-XiaoxiaoNeural";
                }
                const blogId = event.data.blogId;
                //console.log("[originUrl]", originUrl, blogId);
                await this.handleBlogDetail(blogId, originUrl);
              }
            }
            this.init();
          } else if (
            event.data.type === "get-presentation-scroll-data-success"
          ) {
            if (!event.data.data) return;
            const pData = JSON.parse(event.data.data);
            if (pData.length === 0) {
              return;
            }
            if (pData.length !== this.imgUrl.length) return;
            const isUrlReg =
              /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
            pData.forEach((item, index) => {
              if (item.offsetTop) {
                this.imgUrl[index].offsetTop = item.offsetTop;
                if (item.img && isUrlReg.test(item.img)) {
                  this.imgUrl[index].url = item.img;
                }
                this.isGetBlogScrollData = true;
              }
            });
            //console.log("offset pData", pData);
          } else if (event.data.type === "blog-autoplay-tts-presentation") {
            if (this.isStartPlaying) return;
            //console.log("[message:blog-autoplay-tts-presentation]");
            this.isStartPlaying = true;
            // this.handleClickFull(2)
            document.getElementById("blogAutoPlayPPT").click();
          } else if (event.data.type === "issue-presentation-data") {
            if (this.isStarting && this.playMode !== "issue") return;
            if (!event.data) {
              return;
            }
            //console.log("message: ", event.data);

            let { issueDescription, issueAttachments, taskLink } =
              event.data.data;
            this.handleIssueData({
              issueDescription,
              issueAttachments,
              taskLink,
            });
            this.init();
          } else if (event.data.type === "chat") {
            //console.log("hello!", event.data);
            this.handleStopPlay();
            this.isFirst = false;
            this.showTitle = true;
            this.languageShow = false;
            const defaultValue = JSON.parse(event.data.data);
            this.imgUrl = defaultValue;
            this.clickUrl = this.imgUrl[0];
            this.clickIndex = 0;
            this.imgUrl.filter((item) => {
              if (this.isImgType(item.url)) {
                item.animation = "imgRandom";
                item.cycleanimation = 1;
              }
            });
            this.shortAudioScript = event.data.Script ? event.data.Script : "";
            let reg = new RegExp("[\\u4E00-\\u9FFF]");
            if (reg.test(this.shortAudioScript)) {
              this.shortAudioScript = event.data.Script
                ? event.data.Script.replace(/\n/g, "。")
                : "";
              this.imgUrl.scripts =
                this.shortAudioScript.trim().split(/[。？！]/) || [];
              this.selectVoices = "zh-CN-YunyangNeural";
            } else {
              this.shortAudioScript = event.data.Script
                ? event.data.Script.replace(/\n/g, ".")
                : "";
              this.imgUrl.scripts =
                this.shortAudioScript.trim().split(/[.?!]\s+/) || [];
              this.selectVoices = "en-US-AriaNeural";
            }
            this.imgUrl.buffers = [];
            this.init();
          }
        } catch (error) {
          this.$message({
            message: error.message,
            type: "error",
          });
        }
      });
    },
    async getBlogDetail(blogId, blogUrl) {
      try {
        const res = await $postHttp(`${apiUrl}/graphql`, {
          data: {
            query: getPresentationBlogByPlayer,
            variables: {
              blogId: blogId,
              blogUrl: blogUrl,
              type: blogUrl.split(".").length === 1 ? "ftsearch" : "",
            },
          },
        });
        return res;
      } catch (error) {
        return {};
      }
    },
    async handleBlogDetail(blogId, originUrl) {
      const blogDetail = await this.getBlogDetail(blogId, originUrl);
      //console.log("blogDetail", blogDetail);
      if (
        originUrl.split(".").length === 1 &&
        blogDetail.errors &&
        blogDetail.errors.length
      ) {
        this.$message({
          message: blogDetail.errors[0].message,
          type: "error",
        });
        return;
      }
      if (
        blogDetail &&
        blogDetail.data &&
        blogDetail.data.getPresentationBlogByPlayer
      ) {
        // this.createPDR(
        //   blogDetail.data.getPresentationBlogByPlayer.id,
        //   originUrl,
        //   2
        // );
        this.blogData = blogDetail.data.getPresentationBlogByPlayer;
        this.title = this.blogData.blogTitle;
        if (this.blogData.blogBrief && this.blogData.blogBrief !== "") {
          let texts = this.blogData.blogBrief;
          let elText = document.createElement("div");
          elText.innerHTML = texts;
          let text = document.getElementsByTagName("p");
          let imgList = [];
          imgList.length = 0;
          for (const child of elText.children) {
            if (child.tagName == "P") {
              this.blogData.blogbriefText = child.innerText;
            }
            if (child.tagName == "FIGURE") {
              let imgDom = child.innerHTML;
              const RegEx = /(?<=(img src="))[^"]*?(?=")/gims;
              let pictureUrl = imgDom.match(RegEx);
              let imgurlList = pictureUrl.toString();
              imgList.push({ shorturl: imgurlList });
            }
            // this.blogData.blogbriefImg = imgList;
            // console.log("blogbriefImg", this.blogData.blogbriefImg);
          }
          let imgurlList = [];
          this.shortAudioScript = this.blogData.blogbriefText;
          imgList.filter((item) => {
            imgurlList.push({
              url: item.shorturl,
              animation: this.blogData.blogBriefAnimation,
              cycleanimation: 1,
            });
          });
          this.blogData.blogbriefContent = imgurlList;

          let reg = new RegExp("[\\u4E00-\\u9FFF]");
          if (reg.test(this.shortAudioScript)) {
            this.blogData.scripts =
              this.shortAudioScript.trim().split(/[。？！]/) || [];
            this.selectVoices = "zh-CN-YunyangNeural";
            // console.log(
            //   "this.blogData.scripts中文-----------------",
            //   this.blogData.scripts
            // );
          } else {
            this.blogData.scripts =
              this.shortAudioScript.trim().split(/[.?!]\s+/) || [];
            this.selectVoices = "en-US-AriaNeural";
            // console.log(
            //   "this.blogData.scripts其他-----------------",
            //   this.blogData.scripts
            // );
          }
          //console.log("this.blogData-----------", this.blogData);
        }
        if (
          this.blogData.presentationBlogContent.length ===
          this.presentationData.length
        ) {
          for (var i in this.blogData.presentationBlogContent) {
            for (var s in this.presentationData) {
              this.blogData.presentationBlogContent[i].offsetTop =
                this.presentationData[i].offsetTop;
            }
          }
        }
        const language = JSON.parse(
          blogDetail.data.getPresentationBlogByPlayer.languageConfig
        );

        this.languageMain = language.main;
        this.languageConfig = language.config;
        this.speed = this.languageConfig[0].speed;
        this.rangeval = this.languageConfig[0].rangeval;
        this.rate = this.speed ? this.speed * 10 : "10";
        //console.log("rate1",this.rate)
        this.speedList.filter((item) => {
          if (item.value === ((this.speed * 10) / 10).toFixed(2)) {
            this.rangevalSelect = item.label;
          }
        });
        this.languageSelect = this.languageMain
          ? this.languageMain
          : this.languageSelect;
        this.initSpeech();
        this.backgroundBlog =
          blogDetail.data.getPresentationBlogByPlayer.backgroundMusic;
        this.backgroundBlogVolume =
          blogDetail.data.getPresentationBlogByPlayer.volume;
        this.bgmvolume = this.backgroundBlogVolume;
        //console.log(this.backgroundBlog, this.backgroundBlogVolume);
        this.id = blogDetail.data.getPresentationBlogByPlayer.id;
      }
    },
    async getBlogDetailByBlogId(blogId) {
      try {
        const originUrl = window.origin.split("//")[1];
        const domainUrls = originUrl.split(".");
        // const domainUrl = domainUrls.length === 2 ? domainUrls[0] : domainUrls[1]
        let domainUrl = "";
        if (domainUrls[0] === "easiio") {
          domainUrl = domainUrls[1];
        } else {
          domainUrl = domainUrls[0];
        }
        await this.handleBlogDetail(Number(blogId), domainUrl);
        const pptData = this.blogData?.presentationBlogContent.map(
          (item, index) => {
            let url = item.img;
            let name = "name" + index;
            if (!item.img) {
              if (this.isVideoType(item.url)) {
                name = "video" + index;
                url = item.url;
              } else {
                const matchUrl = item?.content?.match(/https?:\/\/[^\s]+/g);
                if (matchUrl && matchUrl[0]) {
                  name = "url";
                } else {
                  url = item.url;
                  name = "url";
                }
                url = item.url;
                if (url.includes("?")) {
                  url += "&ppt=no";
                } else {
                  url += "?ppt=no";
                }
              }
            }
            return {
              id: index + 1,
              name: name,
              description: null,
              url: url,
              page: index + 1,
              script: item.content
                ? item.content
                    .replaceAll("<", "")
                    .replaceAll(">", "")
                    .replaceAll("&", "and")
                    .replaceAll(/[\^@#*]/gi, "")
                : "",
              language: "English",
              offsetTop: item.offsetTop,
              animation: item.animation,
              cycleanimation: item.cycleanimation,
              tagIndex: item.tagIndex,
            };
          }
        );
        this.presentationData = [...pptData];
        this.init();
      } catch (error) {
        console.log("error", error);
      }
    },
    async getIssueDetail(issueIdBase64) {
      try {
        const issueId = window.atob(issueIdBase64);
        const res = await $postHttp(`${apiUrl}/graphql`, {
          data: {
            query: getIssue,
            variables: {
              id: Number(issueId),
            },
          },
          headers: {
            Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIyNmZlZDc3Ni1kMjU1LTRmNGYtODhhYi1kYzY2YjRjODhiMzAiLCJpYXQiOjE2ODQ4MjA2NTIsImV4cCI6MTY4NzQxMjY1Mn0.PJDFbdQI4Eoa3kp9QDOJ5qRkIjw4J3o2j1Ok6lHEdZ4`,
          },
        });
        let issueDescription, issueAttachments;
        try {
          issueDescription = res.data.getIssueWithUsersAndComments.description;
          issueAttachments = res.data.getIssueWithUsersAndComments.attachments;
        } catch (error) {
          throw new Error(cI18n("presentation.noData"));
        }
        this.handleIssueData({ issueDescription, issueAttachments });
        this.init();
        return res;
      } catch (error) {
        if (this.loadingIntance) {
          this.loadingIntance.close();
        }
        this.$message({
          message: error.message,
          type: "error",
        });
      }
    },
    handleIssueData({ issueDescription, issueAttachments, taskLink = "" }) {
      try {
        if (!issueDescription) {
          this.presentationData = [];
          return;
        }
        const parseHtmlParentDOM = document.createElement("div");
        parseHtmlParentDOM.innerHTML = issueDescription;
        let langReg = new RegExp("[\\u4E00-\\u9FFF]");
        const presentationData = this.getArticleContent(parseHtmlParentDOM);
        const presentationDataTemp = [];
        let issueAttachmentsIndex = 0;
        if (Array.isArray(presentationData)) {
          const imgAttachments = [];
          if (Array.isArray(issueAttachments)) {
            issueAttachments.forEach((item) => {
              if (this.isImgType(item.url)) {
                imgAttachments.push(item);
              }
            });
          }
          presentationData.forEach((pItem, pIndex) => {
            let pUrl = pItem.img ? pItem.img : "";
            if (
              Array.isArray(imgAttachments) &&
              imgAttachments[issueAttachmentsIndex] &&
              !pUrl
            ) {
              pUrl = imgAttachments[issueAttachmentsIndex].url;
              issueAttachmentsIndex++;
            }
            presentationDataTemp.push({
              id: pIndex + 1,
              name: pIndex + 1,
              description: null,
              url: pUrl,
              script: pItem.text,
              language: "English",
            });
          });
        }

        if (Array.isArray(issueAttachments)) {
          issueAttachments.forEach((item) => {
            if (this.isVideoType(item.url)) {
              presentationDataTemp.push({
                id: item.id,
                name: item.name,
                description: null,
                url: item.url,
                script: "",
                language: "English",
              });
            }
          });
        }
        presentationDataTemp.forEach((item, index) => {
          if (!item.url) {
            item.url = taskLink;
            item.name = "url";
          }
          item.page = index + 1;
        });
        this.presentationData = presentationDataTemp;
        if (this.presentationData.length && this.presentationData[0].script) {
          if (langReg.test(this.presentationData[0].script)) {
            this.languageSelect = "Chinese";
            this.selectVoices = "zh-CN-YunyangNeural";
          } else {
            this.languageSelect = "English";
            this.selectVoices = "en-US-AriaNeural";
          }
        }
      } catch (error) {
        this.$message({
          message: error.message,
          type: "error",
        });
      }
    },
    isImgType(url) {
      if (url) {
        if (url.includes("data:image") && url.includes("base64")) {
          return true;
        }
        if (url.includes("?")) {
          const urlSplit = url.split("?");
          return this.imgType.includes(
            urlSplit[0].split(".")[urlSplit[0].split(".").length - 1]
          );
        }
        if (this.imgType.includes(url.split(".")[url.split(".").length - 1])) {
          return true;
        }
      }
      return false;
    },
    isVideoType(url) {
      if (url) {
        const videoType = ["3gp", "rmvb", "avi", "mp4", "mov", "webm"];
        if (url.includes("?")) {
          const urlSplit = url.split("?");
          return videoType.includes(
            urlSplit[0].split(".")[urlSplit[0].split(".").length - 1]
          );
        }
        if (videoType.includes(url.split(".")[url.split(".").length - 1])) {
          return true;
        }
      }
      return false;
    },
    getArticleContent(parentDOM) {
      const tags = parentDOM.getElementsByTagName("*");
      const tagExcludes = [
        "html",
        "body",
        "ol",
        "ul",
        "img",
        "figure",
        "a",
        "div",
        "style",
        "iframe",
        "script",
        "blockquote",
        "mark",
        "noscript",
      ];
      let blogContents = [];

      const tagContentExcludes = ["strong"];

      for (let index = 0; index < tags.length; index++) {
        const tag = tags[index];
        const tagNodeName = tag.nodeName;
        if (tagContentExcludes.includes(tagNodeName.toLocaleLowerCase())) {
          const tagParentExcludes = ["li", "p"];
          const contentParent = tag.parentNode;
          if (
            contentParent &&
            tagParentExcludes.includes(
              contentParent.nodeName.toLocaleLowerCase()
            )
          ) {
            continue;
          }
        }
        if (!tagExcludes.includes(tagNodeName.toLocaleLowerCase())) {
          let text = tag.innerText;
          text = text.replaceAll(/<iframe>/gi, "");
          if (text) {
            let nextSibling = tag.nextElementSibling;
            if (nextSibling && nextSibling.nodeType != 1) {
              nextSibling = nextSibling.nextElementSibling;
            }
            //   console.log("nextSibling1", nextSibling, tag, text)

            if (tag.tagName === "LI") {
              let parent = tag.parentNode;
              let siblings = parent.getElementsByTagName("li");
              if (tag === siblings.item(siblings.length - 1)) {
                nextSibling = parent.nextElementSibling;
              }
            }
            let img = null;
            if (nextSibling && nextSibling.nodeName === "IMG") {
              img = nextSibling;
            } else {
              if (nextSibling && nextSibling.getElementsByTagName) {
                img = nextSibling.getElementsByTagName("img").length
                  ? nextSibling.getElementsByTagName("img")[0]
                  : "";
              }
            }
            const re =
              /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
            let src = img ? img.src : "";
            const isUrl = re.test(src);
            if (!isUrl && src) {
              // src = window.origin + src
            }
            const url = window.location.href;
            blogContents.push({
              url,
              text,
              name: "url",
              img: src,
              offsetTop: tag.offsetTop,
              tagName: tag.nodeName,
              tagIndex: index,
              dom: tag,
            });
          } else if (tagNodeName === "VIDEO") {
            blogContents.push({
              url: tag.src,
              text: "",
              name: "name" + index,
              offsetTop: tag.offsetTop,
              tagName: tag.nodeName,
              tagIndex: index,
              dom: tag,
            });
            continue;
          }
        }
      }
      let langReg = new RegExp("[\\u4E00-\\u9FFF]");
      blogContents = blogContents.filter((item) => {
        if (item.text) {
          if (langReg.test(item.text)) {
            return item.text.length > 1;
          } else {
            return item.text.length > 2;
          }
        }
      });
      return blogContents;
    },
    handleAutoNext() {
      //console.log("我的家 的撒反对啊 啊啊    按时");
      if (this.commandFull === 2) {
        // this.updatePDR(this.clickIndex)
        if (this.imgUrl[this.clickIndex].speakTest?.length > 0) {
          this.speechIndex = 0;
          if (
            !this.imgUrl[this.clickIndex].speakTest &&
            this.imgUrl[this.clickIndex].scriptAudio != null
          ) {
            if (
              this.imgUrl[this.clickIndex].playOrder === 1 ||
              this.imgUrl[this.clickIndex].playOrder === 2 ||
              this.imgUrl[this.clickIndex].playOrder === 3
            ) {
              this.caption = false;
              //console.log("script为空，都只播放音频");
              this.scriptAudiourl = new Audio(
                this.imgUrl[this.clickIndex].scriptAudio
              );
              //console.log("this.scriptAudiourl", this.scriptAudiourl);
              this.scriptAudiourl.play();
              this.scriptAudiourl.addEventListener("ended", audioListen);

              return;
            }
          } else if (
            this.imgUrl[this.clickIndex].speakTest &&
            this.imgUrl[this.clickIndex].scriptAudio != null
          ) {
            // console.log(
            //   "this.imgUrl[this.clickIndex].scriptAudio",
            //   this.imgUrl[this.clickIndex].scriptAudio
            // );
            if (this.imgUrl[this.clickIndex].playOrder === 1) {
              // console.log("只播放音频");
              // this.scriptAudiourl = new Audio(
              //   this.imgUrl[this.clickIndex].scriptAudio
              // );
              //console.log("this.scriptAudiourl", this.scriptAudiourl);
              this.scriptAudiourl.play();
              this.scriptAudiourl.addEventListener("ended", this.audioListen);
            }
            if (this.imgUrl[this.clickIndex].playOrder === 2) {
              //console.log("先播放音频后script");
              this.scriptAudiourl = new Audio(
                this.imgUrl[this.clickIndex].scriptAudio
              );
              //console.log("this.scriptAudiourl", this.scriptAudiourl);
              this.scriptAudiourl.play();
              this.scriptAudiourl.addEventListener("ended", this.audioListen);
              this.caption = true;
              return;
            }
            if (this.imgUrl[this.clickIndex].playOrder === 3) {
              //console.log("先script后音频");
              if (
                this.languageSelect == "zh-CN" ||
                this.languageSelect == "Chinese" ||
                this.languageSelect == "Japanese"
              ) {
                this.selectLang = "zh-CN";
                this.speechText = this.parseScriptText(
                  this.imgUrl[this.clickIndex].speakTest,
                  this.languageSelect
                );
              } else {
                this.speechText = this.parseScriptText(
                  this.imgUrl[this.clickIndex].speakTest,
                  this.languageSelect
                );
              }
              this.speak(
                this.speechText?.length > 0
                  ? this.speechText[this.speechIndex]
                  : ""
              );
            }
          } else {
            if (
              this.languageSelect == "zh-CN" ||
              this.languageSelect == "Chinese" ||
              this.languageSelect == "Japanese"
            ) {
              this.selectLang = "zh-CN";
              this.speechText = this.imgUrl[this.clickIndex].speakTest
                ?.trim()
                .split(/[。？！]/);
            } else {
              this.speechText = this.imgUrl[this.clickIndex].speakTest
                ?.trim()
                .split(/[.?!]\s+/);
            }
            this.speak(
              this.speechText?.length > 0
                ? this.speechText[this.speechIndex]
                : ""
            );
          }
          // this.speak(
          //   this.speechText?.length > 0 ? this.speechText[this.speechIndex] : ""
          // );
          return;
        }
        if (this.callToActionEnable === 1) {
          this.lastPageStopPlay();
          if (this.clickIndex < this.imgUrl.length - 1) {
            this.timeout = setTimeout(() => {
              this.clickIndex = (this.clickIndex + 1) % this.imgUrl.length;
              this.clickUrl = this.imgUrl[this.clickIndex];
              this.speakScript(
                this.imgUrl[this.clickIndex].speakTest
                  ? this.imgUrl[this.clickIndex].speakTest
                  : ""
              );
            }, 1000);
          }
        } else {
          this.timeout = setTimeout(() => {
            this.clickIndex = (this.clickIndex + 1) % this.imgUrl.length;
            this.clickUrl = this.imgUrl[this.clickIndex];
            this.speakScript(
              this.imgUrl[this.clickIndex].speakTest
                ? this.imgUrl[this.clickIndex].speakTest
                : ""
            );
          }, 1000);
        }
      } else if (this.command === 1) {
        if (this.callToActionEnable === 1) {
          this.lastPageStopPlay();
          if (this.clickIndex < this.imgUrl.length - 1)
            setTimeout(() => {
              this.clickIndex = (this.clickIndex + 1) % this.imgUrl.length;
              this.clickUrl = this.imgUrl[this.clickIndex];
              this.handleSetInterval(this.autoPlaySlide * 1000);
            }, 2000);
        } else {
          setTimeout(() => {
            this.clickIndex = (this.clickIndex + 1) % this.imgUrl.length;
            this.clickUrl = this.imgUrl[this.clickIndex];
            this.handleSetInterval(this.autoPlaySlide * 1000);
          }, 2000);
        }
      }
      //this.command = 0;
    },
    parseScriptText(scriptText, lang) {
      if (["zh-CN", "Chinese", "Japanese"].includes(lang)) {
        let scripts = scriptText?.trim().split(/[。？！]/) || [];
        scripts = scripts.map((scItem) => scItem.split(/[.?!]\s+/)).flat();
        return scripts;
      } else {
        let scripts = scriptText?.trim().split(/[.?!]\s+/) || [];
        return scripts;
      }
    },
    handleClickNext() {
      // this.updatePDR(this.clickIndex)
      this.clickIndex = (this.clickIndex + 1) % this.imgUrl.length;
      this.clickUrl = this.imgUrl[this.clickIndex];
      //if (this.audioScript) this.audioScript.pause();
      if (this.isPlay === true) {
        if (
          this.playMode === "base" ||
          this.playMode === "blog" ||
          this.playMode === "issue"
        ) {
          if (this.audio) this.audio.pause();
          if (this.audio) {
            this.audio.removeEventListener("ended", this.audioListen);
          }
        }

        // this.audio = "";
        if (this.audioScript) this.audioScript.pause();
        if (this.scriptAudiourl) {
          this.scriptAudiourl.pause();
          this.scriptAudiourl.removeEventListener("ended", this.audioListen);
        }
        clearTimeout(this.timeout);
        this.timeout = "";
        clearInterval(this.intervalTest);
        this.intervalTest = "";
        //console.log(this.commandFull);
        if (
          this.commandFull === 1 ||
          (this.commandFull === 0 && this.isPlay === true) ||
          (this.commandFull === 2 &&
            (this.blogBrief || this.playMode == "chat"))
        ) {
          this.handleSetInterval(this.autoPlaySlide * 1000);
        } else if (this.commandFull === 2) {
          this.speakScript(
            this.imgUrl[this.clickIndex].speakTest
              ? this.imgUrl[this.clickIndex].speakTest
              : ""
          );
        }
      }
    },
    handleClickPre() {
      if (this.clickIndex > 0) {
        // this.updatePDR(this.clickIndex)

        this.clickIndex--;
        this.clickUrl = this.imgUrl[this.clickIndex];
        if (this.isPlay === true) {
          if (this.playMode === "base" || this.playMode === "blog") {
            if (this.audio) this.audio.pause();
            if (this.audio) {
              this.audio.removeEventListener("ended", this.audioListen);
            }
          }
          // this.audio = "";
          //console.log(555555555, this.audioScript);
          if (this.audioScript) this.audioScript.pause();
          if (this.scriptAudiourl) {
            this.scriptAudiourl.pause();
            this.scriptAudiourl.removeEventListener("ended", this.audioListen);
          }
          clearTimeout(this.timeout);
          this.timeout = "";
          clearInterval(this.intervalTest);
          this.intervalTest = "";
          //console.log(this.commandFull);
          if (
            this.commandFull === 1 ||
            (this.commandFull === 0 && this.isPlay === true) ||
            (this.commandFull === 2 &&
              (this.blogBrief || this.playMode == "chat"))
          ) {
            this.handleSetInterval(this.autoPlaySlide * 1000);
          } else if (this.commandFull === 2) {
            if (this.playMode === "base" || this.playMode === "blog") {
              this.speakScript(
                this.imgUrl[this.clickIndex].speakTest
                  ? this.imgUrl[this.clickIndex].speakTest
                  : ""
              );
            }
          }
        }
      }
    },
    handleFolderOpen() {
      if (this.isOpenFolder === false) {
        if (this.isDefault === false) {
          this.isDefault = true;
          this.defaultImgUrl = this.imgUrl;
        }
        this.isOpenFolder = true;
      } else {
        this.isOpenFolder = false;
      }
    },
    bgmplay() {
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      //console.log(isiOS);
      if (this.backgroundMusic && this.command === 2 && isiOS) {
        this.bgmaudio = null;
        this.bgmaudio = new Audio(this.backgroundMusic);
        this.bgmaudio.play();
        this.bgmaudio.volume = this.bgmvolume / 100;
        this.bgmaudio.loop = true;
      }
      if (this.backgroundBlog && this.command === 2 && isiOS) {
        this.bgmaudio = null;
        this.bgmaudio = new Audio(this.backgroundBlog);
        this.bgmaudio.play();
        this.backgroundBlogVolume = this.bgmvolume;
        this.bgmaudio.volume = this.backgroundBlogVolume / 100;
        this.bgmaudio.loop = true;
      }
    },
    speakScript(str) {
      //clearTimeout(timeout.value)
      const speakTest = str.replace(/<[^>]+>/g, "");
      if (this.isVideoType(this.clickUrl.url)) {
        let domVideo = document.getElementById("video_class");
        this.command = 2;
        //this.speechText = [];
        domVideo.currentTime = 0;
        this.controlVideoToPlay(domVideo);
        domVideo?.addEventListener("ended", this.bgmplay);
      } else {
        if (
          (!speakTest && this.imgUrl[this.clickIndex].scriptAudio == null) ||
          (speakTest &&
            speakTest.length === 0 &&
            this.imgUrl[this.clickIndex].scriptAudio == null)
        ) {
          this.timeout = setTimeout(() => {
            this.clickIndex = (this.clickIndex + 1) % this.imgUrl.length;
            this.clickUrl = this.imgUrl[this.clickIndex];
            this.speakScript(
              this.imgUrl[this.clickIndex].speakTest
                ? this.imgUrl[this.clickIndex].speakTest
                : ""
            );
          }, 3000);
        } else if (
          (!speakTest && this.imgUrl[this.clickIndex].scriptAudio != null) ||
          (speakTest.length === 0 &&
            this.imgUrl[this.clickIndex].scriptAudio != null)
        ) {
          if (
            this.imgUrl[this.clickIndex].playOrder === 1 ||
            this.imgUrl[this.clickIndex].playOrder === 2 ||
            this.imgUrl[this.clickIndex].playOrder === 3
          ) {
            this.caption = false;
            //console.log("script为空，都只播放音频");
            this.scriptAudiourl = new Audio(
              this.imgUrl[this.clickIndex].scriptAudio
            );
            //console.log("this.scriptAudiourl", this.scriptAudiourl);
            this.scriptAudiourl.play();
            this.scriptAudiourl.addEventListener("ended", this.audioListen);

            return;
          }
        } else {
          let speech = [];
          if (
            this.languageSelect == "zh-CN" ||
            this.languageSelect == "Chinese" ||
            this.languageSelect == "Japanese"
          ) {
            this.selectLang = "zh-CN";
            speech = this.parseScriptText(
              this.imgUrl[this.clickIndex].speakTest,
              this.selectLang
            );
          } else {
            speech = this.parseScriptText(
              this.imgUrl[this.clickIndex].speakTest,
              this.languageSelect
            );
          }
          //console.log(this.speechText);
          this.speechIndex = 0;
          // this.speak(
          //   this.speechText?.length > 0 ? this.speechText[this.speechIndex] : ""
          // );
          if (
            this.imgUrl[this.clickIndex].speakTest &&
            this.imgUrl[this.clickIndex].scriptAudio != null
          ) {
            // console.log(
            //   "this.imgUrl[this.clickIndex].scriptAudio",
            //   this.imgUrl[this.clickIndex].scriptAudio
            // );
            if (this.imgUrl[this.clickIndex].playOrder === 1) {
              //console.log("只播放音频");
              this.speechText = [];
              this.scriptAudiourl = new Audio(
                this.imgUrl[this.clickIndex].scriptAudio
              );
              //console.log("this.scriptAudiourl", this.scriptAudiourl);
              this.scriptAudiourl.play();
              this.scriptAudiourl.addEventListener("ended", this.audioListen);
            }
            if (this.imgUrl[this.clickIndex].playOrder === 2) {
              // console.log("先播放音频后script");
              this.speechText = [];
              this.scriptAudiourl = new Audio(
                this.imgUrl[this.clickIndex].scriptAudio
              );
              //console.log("this.scriptAudiourl", this.scriptAudiourl);
              this.scriptAudiourl.play();
              this.scriptAudiourl.addEventListener("ended", this.audioListen);
              this.caption = true;
              return;
            }
            if (this.imgUrl[this.clickIndex].playOrder === 3) {
              //console.log("先script后音频");
              this.speechText = speech;
              this.speak(
                this.speechText?.length > 0
                  ? this.speechText[this.speechIndex]
                  : ""
              );
            }
          }
          if (this.imgUrl[this.clickIndex].scriptAudio == null) {
            this.caption = true;
            //console.log("没有音频");
            this.speechText = speech;
            this.speak(
              this.speechText?.length > 0
                ? this.speechText[this.speechIndex]
                : ""
            );
          }
        }
      }
    },
    handleClickPPT(index) {
      //console.log("index", index);
      this.clickUrl = this.imgUrl[index];
      this.clickIndex = index;
      //console.log("this.clickUrl", this.clickUrl);
      if (this.isPlay === true) {
        if (
          this.playMode === "base" ||
          this.playMode === "blog" ||
          this.playMode === "issue"
        ) {
          if (this.audio) this.audio.pause();
          if (this.audio) {
            this.audio.removeEventListener("ended", this.audioListen);
          }
        }
        // this.audio = "";
        if (this.audioScript) this.audioScript.pause();
        if (this.scriptAudiourl) {
          this.scriptAudiourl.pause();
          this.scriptAudiourl.removeEventListener("ended", this.audioListen);
        }
        clearTimeout(this.timeout);
        this.timeout = "";
        clearInterval(this.intervalTest);
        this.intervalTest = "";
        //console.log(this.commandFull);
        if (
          this.commandFull === 1 ||
          (this.commandFull === 0 && this.isPlay === true) ||
          (this.commandFull === 2 &&
            (this.blogBrief || this.playMode == "chat"))
        ) {
          this.handleSetInterval(this.autoPlaySlide * 1000);
        } else if (this.commandFull === 2) {
          if (
            this.playMode === "base" ||
            this.playMode === "blog" ||
            this.playMode === "issue"
          ) {
            this.speakScript(
              this.imgUrl[this.clickIndex].speakTest
                ? this.imgUrl[this.clickIndex].speakTest
                : ""
            );
          }
        }
      }
    },
    speak(text) {
      //console.log(this.audio);
      if (this.blogBrief || this.playMode == "chat") {
        if (this.audio) this.audio.pause();
        if (this.imgUrl.buffers[this.speechIndex]) {
          const blob = new Blob(
            [new Uint8Array(this.imgUrl.buffers[this.speechIndex])],
            {
              type: "audio/mp3",
            }
          );
          // this.audio.pause();
          // this.audio = new Audio(URL.createObjectURL(blob));
          this.audio.src = URL.createObjectURL(blob);
          this.audio.currentTime = 0;
          //console.log(this.audio);
          //this.audio.load();
          setTimeout(() => {
            this.audio.play();
          }, 200);
          this.audio?.addEventListener("play", () => {
            if (this.isPlay === false && this.audio) {
              this.audio.pause();
            }
          });
          this.audio?.addEventListener("ended", this.speakAudio);
        }
      } else {
        if (this.audio) this.audio.pause();
        if (
          this.imgUrl[this.clickIndex].buffers &&
          this.imgUrl[this.clickIndex].buffers[this.speechIndex] &&
          this.imgUrl[this.clickIndex].buffers[this.speechIndex].length
        ) {
          const blob = new Blob(
            [
              new Uint8Array(
                this.imgUrl[this.clickIndex].buffers[this.speechIndex]
              ),
            ],
            {
              type: "audio/mp3",
            }
          );
          // this.audio.pause();
          // this.audio = new Audio(URL.createObjectURL(blob));
          this.audio.src = URL.createObjectURL(blob);
          this.audio.currentTime = 0;
          //console.log(this.audio);
          setTimeout(() => {
            this.audio.play();
          }, 200);
          this.audio?.addEventListener("play", () => {
            if (this.isPlay === false && this.audio) {
              this.audio.pause();
            }
          });
          this.audio?.addEventListener("ended", this.audioListen);
          return;
        }
        this.getAudio(text)
          .then((url) => {
            // if (this.audio) this.audio.pause();
            // this.audio = new Audio(url);
            this.audio.src = url;
            this.audio.currentTime = 0;
            setTimeout(() => {
              this.audio.play();
            }, 200);
            this.audio?.addEventListener("play", () => {
              if (this.isPlay === false && this.audio) {
                this.audio.pause();
              }
            });
            this.audio?.addEventListener("ended", this.audioListen);
          })
          .catch((err) => {});
      }
    },
    sleep() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve();
        }, 1000 * 20);
      });
    },
    async audioListen() {
      // this.speechIndex++;
      if (this.isPlay === true) {
        if (
          this.languageSelect == "zh-CN" ||
          this.languageSelect == "Chinese" ||
          this.languageSelect == "Japanese"
        ) {
          this.selectLang = "zh-CN";
          this.speechText = this.parseScriptText(
            this.imgUrl[this.clickIndex].speakTest,
            this.languageSelect
          );
        } else {
          this.speechText = this.parseScriptText(
            this.imgUrl[this.clickIndex].speakTest,
            this.languageSelect
          );
        }
        if (this.speechIndex === this.speechText.length) {
          if (
            this.clickIndex === this.imgUrl.length - 1 &&
            this.playMode === "blog"
          ) {
            if (this.callToActionEnable === 1) this.lastPageStopPlay();
            //this.lastPageStopPlay();
            console.time("blogplayend");
            await this.sleep();
            console.timeEnd("blogplayend");
          }
          setTimeout(() => {
            this.clickIndex = (this.clickIndex + 1) % this.imgUrl.length;
            this.clickUrl = this.imgUrl[this.clickIndex];
            this.speakScript(
              this.imgUrl[this.clickIndex].speakTest
                ? this.imgUrl[this.clickIndex].speakTest
                : ""
            );
          }, 1000);
        } else {
          const str = this.speechText[this.speechIndex].replace(/<[^>]+>/g, "");
          if (
            this.isSpeak === false &&
            this.imgUrl[this.clickIndex].playOrder === 2 &&
            this.imgUrl[this.clickIndex].scriptAudio != null &&
            this.imgUrl[this.clickIndex].speakTest != ""
          ) {
            this.isSpeak = true;
            if (this.speechText[this.speechIndex].length > 0)
              this.speak(this.speechText[this.speechIndex]);
            else {
              this.audioListen();
            }
            return;
          }
          //this.isSpeak = false;
          // this.speak(this.speechText[this.speechIndex]);
          // console.log(
          //   "this.speechIndex",
          //   this.speechIndex,
          //   this.speechText.length - 1
          // );
          if (this.speechIndex === this.speechText.length - 1) {
            if (
              this.clickIndex === this.imgUrl.length - 1 &&
              this.playMode == "issue"
            ) {
              this.handleStopPlay();
              return;
            }
            if (
              this.isSpeak === false &&
              this.imgUrl[this.clickIndex].playOrder === 3 &&
              this.imgUrl[this.clickIndex].scriptAudio != null &&
              this.imgUrl[this.clickIndex].speakTest != ""
            ) {
              this.isSpeak = true;
              this.scriptAudiourl = new Audio(
                this.imgUrl[this.clickIndex].scriptAudio
              );
              this.scriptAudiourl.play();
              this.scriptAudiourl.addEventListener("ended", this.audioListen);
              this.caption = false;
              return;
            } else {
              if (this.callToActionEnable === 1) {
                this.lastPageStopPlay();
                if (this.clickIndex < this.imgUrl.length - 1)
                  setTimeout(() => {
                    this.isSpeak = false;
                    this.clickIndex =
                      (this.clickIndex + 1) % this.imgUrl.length;
                    this.clickUrl = this.imgUrl[this.clickIndex];
                    this.speakScript(
                      this.imgUrl[this.clickIndex].speakTest
                        ? this.imgUrl[this.clickIndex].speakTest
                        : ""
                    );
                  }, 1000);
              } else {
                setTimeout(() => {
                  this.isSpeak = false;
                  this.clickIndex = (this.clickIndex + 1) % this.imgUrl.length;
                  this.clickUrl = this.imgUrl[this.clickIndex];
                  this.speakScript(
                    this.imgUrl[this.clickIndex].speakTest
                      ? this.imgUrl[this.clickIndex].speakTest
                      : ""
                  );
                }, 1000);
              }
            }
          }
          if (this.speechIndex < this.speechText.length - 1) {
            this.speechIndex++;
            if (this.speechText[this.speechIndex].length > 0)
              this.speak(this.speechText[this.speechIndex]);
            else {
              this.audioListen();
            }
            // if (
            //   this.isSpeak === true &&
            //   this.imgUrl[this.clickIndex].playOrder === 2 &&
            //   this.imgUrl[this.clickIndex].scriptAudio != null
            // ) {
            //   this.speak(this.speechText[this.speechIndex]);
            // } else {
            //   this.speak(this.speechText[this.speechIndex]);
            // }
          }
        }
      }
    },
    guid() {
      function gen(count) {
        var out = "";
        for (var i = 0; i < count; i++) {
          out += (((1 + Math.random()) * 0x10000) | 0)
            .toString(16)
            .substring(1);
        }
        return out;
      }
      return gen(8);
    },
    speechConfig(audioOutputFormat = "audio-24khz-48kbitrate-mono-mp3") {
      return `X-Timestamp:${new Date()}\r\nContent-Type:application/json; charset=utf-8\r\nPath:speech.config\r\n\r\n{"context":{"synthesis":{"audio":{"metadataoptions":{"sentenceBoundaryEnabled":"false","wordBoundaryEnabled":"true"},"outputFormat":"${audioOutputFormat}"}}}}`;
    },
    ssmlText({
      requestId = guid(),
      lan = "zh-CN",
      voiceName,
      pitch = "+0",
      rate = "+0",
      volume = "+0",
      text,
    }) {
      return `X-RequestId:${requestId}\r\nContent-Type:application/ssml+xml\r\nX-Timestamp:${new Date()}\r\nPath:ssml\r\n\r\n<speak version='1.0' xmlns='http://www.w3.org/2001/10/synthesis' xmlns:mstts='https://www.w3.org/2001/mstts' xml:lang='${lan}'><voice name='${voiceName}'><prosody pitch='${pitch}Hz' rate ='${rate}%' volume='${volume}%'>${text}</prosody></voice></speak>`;
    },
    getPreloadAudio(text, textList) {
      // if(audio.value)
      //   audio.value.pause();
      let bufferList = [];
      const textEncoder = new TextEncoder();
      const binaryHeadEnd = textEncoder.encode("Path:audio\r\n").toString();
      //this.currentTTSText = [-1, 0];
      // let currentTTSIndex = 0;
      return new Promise((resolve, reject) => {
        const requestId = this.guid();
        const ws = new WebSocket(
          "wss://speech.platform.bing.com/consumer/speech/synthesize/readaloud/edge/v1?TrustedClientToken=6A5AA1D4EAFF4E9FB37E23D68491D6F4"
        );
        ws.addEventListener("open", () => {
          ws.send(this.speechConfig());
          try {
            sendTTSText();
          } catch (e) {}
        });
        const sendTTSText = () => {
          if (!ws) return;
          if (this.blogBrief || this.playMode == "chat") {
            //console.log(this.imgUrl.scripts);
            if (
              this.currentTTSText[0] === this.imgUrl.scripts?.length - 1 ||
              this.imgUrl.scripts.length === 0
            ) {
              ws.close(1000);
              return;
            }
            if (this.currentTTSIndex == 1) {
              resolve();
            }
            this.currentTTSText[0] += 1;
            this.currentTTSIndex++;
            // this.currentTTSText += 1
            const requestId = this.guid();
            //console.log("this.imgUrl[this.currentTTSText[0]]", this.currentTTSText);
            if (
              this.imgUrl.scripts?.length > 0 &&
              this.imgUrl.scripts[this.currentTTSText[0]].length > 0
            ) {
              let textWord =
                this.imgUrl.scripts?.length > 0
                  ? this.imgUrl.scripts[this.currentTTSText[0]]
                  : "";
              textWord = textWord
                .replaceAll("<", "")
                .replaceAll(">", "")
                .replaceAll("&", "and")
                .replaceAll(/[\^@#*]/gi, "");
              ws.send(
                this.ssmlText({
                  requestId,
                  text: textWord,
                  //lan: this.selectLang,
                  voiceName: this.selectVoices,
                  pitch: "+10",
                  rate: "+" + this.rate,
                })
              );
            }
          } else {
            if (
              this.currentTTSText[0] === this.imgUrl?.length - 1 &&
              this.currentTTSText[1] ===
                this.imgUrl[this.imgUrl.length - 1].scripts?.length - 1
            ) {
              ws.close(1000);
              return;
            }
            if (this.currentTTSIndex == 1) {
              resolve();
            }
            if (
              (this.imgUrl[this.currentTTSText[0]] &&
                this.imgUrl[this.currentTTSText[0]].scripts?.length - 1 <=
                  this.currentTTSText[1]) ||
              this.currentTTSText[0] === -1 ||
              this.imgUrl[this.currentTTSText[0]].scripts.length === 0
            ) {
              this.currentTTSText[0] += 1;
              this.currentTTSText[1] = 0;
            } else {
              this.currentTTSText[1] += 1;
            }
            this.currentTTSIndex++;
            // this.currentTTSText += 1
            const requestId = this.guid();
            // console.log(
            //   "this.imgUrl[this.currentTTSText[0]]",
            //   this.currentTTSText
            // );
            if (this.imgUrl[this.currentTTSText[0]]) {
              this.imgUrl[this.currentTTSText[0]].buffers[
                this.currentTTSText[0]
              ] = [];
              let textWord =
                this.imgUrl[this.currentTTSText[0]].scripts?.length > 0
                  ? this.imgUrl[this.currentTTSText[0]].scripts[
                      this.currentTTSText[1]
                    ]
                  : "";
              textWord = textWord
                .replaceAll("<", "")
                .replaceAll(">", "")
                .replaceAll("&", "and")
                .replaceAll(/[\^@#*]/gi, "");

              if (!textWord) {
                sendTTSText();
                return;
              }
              ws.send(
                this.ssmlText({
                  requestId,
                  text: textWord,
                  //lan: this.selectLang,
                  voiceName: this.selectVoices,
                  pitch: "+10",
                  rate: "+" + this.rate,
                })
              );
            }
          }
        };
        ws.addEventListener("message", async ({ data }, ...arg) => {
          // console.log("prop---------", arg);
          if (data instanceof Blob) {
            const view = new Uint8Array(await data.arrayBuffer());
            bufferList.push(
              ...view
                .toString()
                .split(binaryHeadEnd)[1]
                .split(",")
                .slice(1)
                .map((i) => +i)
            );
            //console.log(bufferList);
            if (view[0] == 0x00 && view[1] == 0x67 && view[2] == 0x58) {
              //console.log(bufferList);
              if (this.blogBrief || this.playMode == "chat") {
                this.imgUrl.buffers.push(bufferList);
              } else {
                if (this.imgUrl[this.currentTTSText[0]])
                  this.imgUrl[this.currentTTSText[0]].buffers[
                    this.currentTTSText[1]
                  ] = bufferList;
              }
              bufferList = [];
              sendTTSText();
              // ws.close(1000);
            }
          }
        });
        ws.addEventListener("error", (err) => {
          console.log("------出错了", err);
          // reject(err);
          this.getPreloadAudio()
            .then((res) => resolve(res))
            .catch((error) => reject(error));
        });
        ws.addEventListener("close", (event) => {
          if (event.code != 1000 && event.code != 1006) {
            console.error("----关闭了", event);
            reject(event.code);
            return;
          }
          // const blob = new Blob([new Uint8Array(bufferList)], {
          //   type: "audio/mjpeg",
          // });
          // resolve(URL.createObjectURL(blob));
          resolve();
        });
      });
    },
    getAudio(text) {
      // if(audio.value)
      //   audio.value.pause();
      const bufferList = [];
      const textEncoder = new TextEncoder();
      const binaryHeadEnd = textEncoder.encode("Path:audio\r\n").toString();
      return new Promise((resolve, reject) => {
        const requestId = this.guid();
        const ws = new WebSocket(
          "wss://speech.platform.bing.com/consumer/speech/synthesize/readaloud/edge/v1?TrustedClientToken=6A5AA1D4EAFF4E9FB37E23D68491D6F4"
        );
        ws.addEventListener("open", () => {
          ws.send(this.speechConfig());
          ws.send(
            this.ssmlText({
              requestId,
              text: text
                .replaceAll("<", "")
                .replaceAll(">", "")
                .replaceAll("&", "and")
                .replaceAll(/[\^@#*]/gi, ""),
              //lan: this.selectLang,
              voiceName: this.selectVoices,
              pitch: "+10",
              rate: "+" + this.rate,
            })
          );
        });
        ws.addEventListener("message", async ({ data }) => {
          if (data instanceof Blob) {
            const view = new Uint8Array(await data.arrayBuffer());
            bufferList.push(
              ...view
                .toString()
                .split(binaryHeadEnd)[1]
                .split(",")
                .slice(1)
                .map((i) => +i)
            );
            if (view[0] == 0x00 && view[1] == 0x67 && view[2] == 0x58) {
              ws.close(1000);
            }
          }
        });
        ws.addEventListener("error", (err) => {
          console.log("------出错了", err);
          // reject(err);
          this.getAudio(text)
            .then((res) => resolve(res))
            .catch((error) => reject(error));
        });
        ws.addEventListener("close", (event) => {
          if (event.code != 1000 && event.code != 1006) {
            console.error("----关闭了", event);
            reject(event.code);
            return;
          }
          const blob = new Blob([new Uint8Array(bufferList)], {
            type: "audio/mp3",
          });
          resolve(URL.createObjectURL(blob));
        });
      });
    },
    async handleClickFull(command) {
      // 记录PDR
      this.handleStopPlay(this.commandFull);
      if (command === 2 && !this.pdrId) {
        if (this.playMode === "blog") {
          if (this.blogData.id && this.blogData.blogUrl) {
            const urlStrs = this.blogData.blogUrl.split("/");
            const originUrl = urlStrs[2];
            this.createPDR(this.blogData.id, originUrl, 2);
          }
        } else if (this.playMode === "base") {
          this.createPDR(this.presentationId, window.location.href, 1);
        }
      }
      if (!this.audio) {
        this.audio = new Audio("https://file.sflow.pro/silence.mp3");
        this.audio.play();
      } else {
        this.audio.src = "https://file.sflow.pro/silence.mp3";
        this.audio.play();
      }
      this.isPlay = true;
      this.clickPlay = true;
      this.isMouseOver = false;
      this.isSpeak = false;
      this.commandFull = command;
      let domImg = document.getElementById("image_id");
      if (domImg) domImg.className = "image_class";
      let animation =
        this.imgUrl[this.clickIndex] &&
        this.imgUrl[this.clickIndex].animation !== null
          ? this.imgUrl[this.clickIndex].animation
          : "";
      if (this.playMode === "blog") {
        animation =
          this.imgUrl[this.clickIndex] &&
          this.imgUrl[this.clickIndex].animation !== null
            ? this.imgUrl[this.clickIndex].animation
            : "imgRandom";
      }
      this.animation = animation;
      if (animation) {
        if (animation == "imgRandom") {
          const animationList = [
            "imgZoomin",
            "imgZoominandOut",
            "imgScanLeft",
            "imgScanRight",
            "imgSrolldown",
            "imgScrolldownUp",
          ];
          const randomInt = Math.floor(Math.random() * 6);
          animation = animationList[randomInt];
          this.animation = animation;
        }
        setTimeout(() => {
          domImg.className = "image_class " + animation;
        }, 10);
      }
      if (command == 2) {
        if (this.imgUrl.length === 0) {
          this.$message({
            message: cI18n("presentation.noData"),
            type: "error",
          });
        }

        //背景音乐
        if (!this.bgmaudio || this.bgmaudio === "") {
          if (
            (this.backgroundMusic && this.playMode === "base") ||
            (this.backgroundMusic && this.playMode === "short")
          ) {
            this.bgmaudio = new Audio(this.backgroundMusic);
            this.bgmaudio.play();
            this.bgmaudio.volume = this.bgmvolume / 100;
            this.bgmaudio.loop = true;
          }
          if (
            (this.backgroundBlog && this.playMode == "blog") ||
            (this.backgroundBlog && this.playMode == "brief")
          ) {
            this.bgmaudio = new Audio(this.backgroundBlog);
            this.bgmaudio.play();
            this.backgroundBlogVolume = this.bgmvolume;
            this.bgmaudio.volume = this.backgroundBlogVolume / 100;
            this.bgmaudio.loop = true;
          }
        }

        let test = 0;
        if (this.isFirst === false) {
          this.isFirst = true;
          this.clickIndex = 0;
          this.clickUrl = this.imgUrl[0];
        }
        this.imgUrl.filter((item) => {
          if (
            (!item.script ||
              item.script.replace(/<[^>]+>/g, "").length === 0) &&
            (!item.videoSpeakText || item.videoSpeakText.length === 0)
          ) {
            test++;
          }
        });
        if (
          test === this.imgUrl?.length &&
          (!this.imgUrl.scripts || this.imgUrl.scripts.length === 0)
        ) {
          this.$message({
            message: this.chineseWebsite
              ? "此演示文稿没有可播放的脚本."
              : "No Script to play",
            type: "error",
          });
        }
        if (this.playMode === "base") {
          const res = await $postHttp(`${apiUrl}/graphql`, {
            data: {
              query: updatePresentationStatistics,
              variables: {
                presentationId: this.presentationId,
                type: "play",
              },
            },
          });
        } else if (this.playMode === "blog") {
          const res = await $postHttp(`${apiUrl}/graphql`, {
            data: {
              query: getPresentationBlog,
              variables: {
                id: this.id,
                type: "views",
              },
            },
          });
          const resStatistics = await $postHttp(`${apiUrl}/graphql`, {
            data: {
              query: getPresentationBlog,
              variables: {
                id: this.id,
                type: "imps",
              },
            },
          });
        }
        if (
          this.languageSelect == "zh-CN" ||
          this.languageSelect == "Chinese" ||
          this.languageSelect == "Japanese"
        ) {
          this.imgUrl.forEach((item) => {
            item.scripts = this.parseScriptText(
              item.speakTest,
              this.languageSelect
            );
            item.buffers = new Array(item.scripts?.length);
          });
        } else {
          this.imgUrl.forEach((item) => {
            item.scripts = this.parseScriptText(
              item.speakTest,
              this.languageSelect
            );
            item.buffers = new Array(item.scripts?.length);
          });
        }
        this.currentTTSText = [-1, 0];
        this.currentTTSIndex = 0;
        this.isOpenFolder = false;
        this.getPreloadAudio()
          .then((res) => {
            //console.log("this.==========", this.imgUrl);
            // return
            if (this.blogBrief || this.playMode == "chat") {
              //console.log(111, this.imgUrl);
              this.speakAudioScript();
            } else {
              this.speakScript(
                this.imgUrl[this.clickIndex].speakTest
                  ? this.imgUrl[this.clickIndex].speakTest
                  : ""
              );
            }
          })
          .catch((error) => {
            this.$message({
              message: error.message,
              type: "error",
            });
          });
        // }
      } else {
        if (this.imgUrl.length === 0) {
          this.$message({
            message: this.chineseWebsite ? "无数据" : "No data",
            type: "error",
          });
          this.isPlay = false;
          return;
        }
        this.handleSetInterval(this.autoPlaySlide * 1000);
      }
    },
    handleStopPlay(command = 0) {
      this.isPlay = false;
      this.isSpeak = false;
      this.speechText = [];
      this.commandFull = command;
      clearTimeout(this.animationTimeOut);
      let domVideo = document.getElementById("video_class");
      domVideo.autoplay = false;
      domVideo.pause();
      domVideo.removeEventListener("canplay", this.handleAutoNext);
      domVideo.removeEventListener("ended", this.handleAutoNext);
      if (this.audio) {
        this.audio.pause();
        this.audio.removeEventListener("ended", this.audioListen);
        this.audio.removeEventListener("ended", this.speakAudio);
      }
      if (this.audioScript) {
        this.audioScript.pause();
      }
      if (this.scriptAudiourl) {
        this.scriptAudiourl.pause();
        this.scriptAudiourl.removeEventListener("ended", this.audioListen);
      }
      if (this.bgmaudio) {
        this.bgmaudio.pause();
        this.bgmaudio = "";
      }
      // this.audio = "";
      clearTimeout(this.timeout);
      this.timeout = "";
      clearInterval(this.intervalTest);
      this.intervalTest = "";
    },
    initSpeech() {
      let index = 0;
      let isVoice = false;
      if (this.playMode !== "short" && this.playMode !== "brief")
        this.languageConfig.filter((item) => {
          if (item.language == this.languageSelect && isVoice === false) {
            this.selectVoices = item.voice;
            isVoice = true;
          }
        });
      // console.log("this.imgUrl+++++++++", this.imgUrl);
      if (this.playMode == "blog") {
        // console.log(33333333333333);
        this.blogData.presentationBlogContent.forEach((item, itemIndex) => {
          // console.log("item---------", item);
          if (item.presentationBlogContentTranslation.length > 0) {
            item.presentationBlogContentTranslation.filter((itemSpeak) => {
              if (itemSpeak.language == this.languageSelect) {
                if (this.imgUrl[itemIndex])
                  this.imgUrl[itemIndex].speakTest =
                    itemSpeak.translationContent;
                else {
                  item.speakTest = itemSpeak.translationContent;
                }
              }
            });
          } else {
            index++;
            if (this.imgUrl[itemIndex])
              this.imgUrl[itemIndex].speakTest = item.content;
            else {
              item.speakTest = item.content;
            }
          }
        });
      } else if (this.playMode == "base") {
        this.imgUrl.forEach((item) => {
          //console.log("item---------", item);
          item.videoSpeakText = [];
          if (item.presentationDetailScriptTranslation.length > 0) {
            item.presentationDetailScriptTranslation.filter((itemSpeak) => {
              if (itemSpeak.language == this.languageSelect) {
                // console.log(
                //   "itemSpeak.translationScript",
                //   itemSpeak.translationScript
                // );
                item.speakTest = itemSpeak.translationScript;
              }
            });
          } else {
            index++;
            item.speakTest = item.script;
          }
          if (item.presentationDetailVideoScript.length > 0) {
            item.presentationDetailVideoScript.filter((itemSpeak) => {
              if (
                itemSpeak.presentationDetailVideoScriptTranslation.length > 0
              ) {
                itemSpeak.presentationDetailVideoScriptTranslation.filter(
                  (itemSpeakTranslate) => {
                    if (
                      itemSpeakTranslate.language == this.languageSelect &&
                      itemSpeakTranslate.translationText.length > 0
                    ) {
                      item.videoSpeakText.push({
                        text: itemSpeakTranslate.translationText,
                        start: itemSpeak.start,
                      });
                    }
                  }
                );
              } else {
                if (itemSpeak.textGPT && itemSpeak.textGPT.length > 0)
                  item.videoSpeakText.push({
                    text: itemSpeak.textGPT,
                    start: itemSpeak.start,
                  });
              }
            });
          }
          this.currentTTSVideoText[0] = -1;
          this.getPreloadVideoScript(item);
        });
      }
      // console.log(this.imgUrl);
    },
    handleChangeLanguage(item) {
      this.speed = item.speed;
      this.rangeval = ((item.rangeval * 10) / 10).toFixed(2);
      this.rate = this.rangeval * 10;
      this.speedList.filter((item) => {
        if (item.value === ((this.speed * 10) / 10).toFixed(2)) {
          this.rangevalSelect = item.label;
        }
      });
      this.languageSelect = item.language;
      this.initSpeech();
      if (this.clickUrl.script && this.isPlay === true) {
        if (this.audio) this.audio.pause();
        if (this.audio) {
          this.audio.removeEventListener("ended", this.audioListen);
        }
        // this.audio = "";
        if (this.scriptAudiourl) {
          this.scriptAudiourl.pause();
          this.scriptAudiourl.removeEventListener("ended", this.audioListen);
        }
        clearTimeout(this.timeout);
        this.timeout = "";
        clearInterval(this.intervalTest);
        this.intervalTest = "";
        //console.log(this.commandFull);
        if (this.commandFull === 2) {
          this.speechText = [];
          this.handleClickFull(2);
        }
      }
    },
    multiLanguage(str) {
      return cI18n(str);
    },
    postIframeScrollMsg(iframeDom, id) {
      const index = this.imgUrl.findIndex((item) => item.id === id);
      const item = this.imgUrl[index];
      if (!item) return;
      let scrollY = item.offsetTop;
      let text = item.speakTest;
      let tagIndex = item.tagIndex;
      if (!scrollY) return;
      let scrollYTemp = scrollY;
      if (scrollYTemp > 150) {
        scrollYTemp -= 150;
      }
      if (iframeDom.contentWindow) {
        iframeDom.contentWindow.postMessage(
          {
            type: "change-presentation-scroll",
            data: {
              scrollY: scrollYTemp,
              text,
              index,
              tagIndex,
            },
          },
          "*"
        );
      }
    },
    postGetBlogScrollData(iframeDom) {
      if (this.isGetBlogScrollData) return;
      setTimeout(() => {
        iframeDom.contentWindow.postMessage(
          {
            type: "get-presentation-scroll-data",
            data: {},
          },
          "*"
        );
      }, 1000 * 5);
    },
    volumechange(bgmvolume) {
      //console.log("bgmvolume", bgmvolume);
      //console.log("this.bgmaudio", this.bgmaudio);
      this.bgmaudio.volume = bgmvolume / 100;
      //console.log(this.bgmaudio.volume);
    },
    handleFullScreen() {
      let docElm = document.body;
      const width = document.documentElement.clientWidth;
      const height = document.documentElement.clientHeight;
      if (this.isMobile) {
        docElm = document.getElementById("canvas_class");
        const evt =
          "onorientationchange" in window ? "orientationchange" : "resize";
        window.addEventListener(
          evt,
          function () {
            if (window.orientation === 90 || window.orientation === -90) {
              docElm.style.width = "100%";
              docElm.style.height = "100%";
              docElm.style.top = 0;
              docElm.style.left = 0;
              docElm.style.transform = "rotate(0)";
            } else {
              docElm.style.width = height + "px";
              docElm.style.height = width + "px";
              docElm.style.top = (height - width) / 2 + "px";
              docElm.style.left = 0 - (height - width) / 2 + "px";
              docElm.style.transform = "rotate(90deg)";
            }
          },
          false
        );
        if (docElm.style.transform === "rotate(90deg)") {
          docElm.style.width = "100%";
          docElm.style.height = "100%";
          docElm.style.top = 0;
          docElm.style.left = 0;
          docElm.style.transform = "rotate(0)";
        } else {
          docElm.style.width = height + "px";
          docElm.style.height = width + "px";
          docElm.style.top = (height - width) / 2 + "px";
          docElm.style.left = 0 - (height - width) / 2 + "px";
          docElm.style.transform = "rotate(90deg)";
        }
      } else {
        if (!document.fullscreenElement) {
          this.isFull = false;
          if (docElm.requestFullscreen) docElm.requestFullscreen();
          else if (docElm.mozRequestFullScreen) docElm.mozRequestFullScreen();
          else if (docElm.webkitRequestFullScreen)
            docElm.webkitRequestFullScreen();
          else if (docElm.msRequestFullscreen) docElm.msRequestFullscreen();
        } else {
          this.isFull = true;
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        }
      }
    },
    handleMouseOver() {
      clearTimeout(this.mouseTimeOut);
      this.mouseTimeOut = setInterval(() => {
        if (this.isClick === false) this.isMouseOver = false;
        this.isClick = false;
      }, 3000);
    },
    handleMouseLeave() {
      clearInterval(this.mouseTimeOut);
      this.mouseTimeOut = setTimeout(() => {
        this.isMouseOver = false;
      }, 3000);
    },
    handleMouseMove() {
      this.isMouseOver = true;
      this.isClick = true;
    },
    handleTouch() {
      clearTimeout(this.mouseTimeOut);
      this.isMouseOver = true;
    },
    handleClickPlay() {
      if (this.isFirst === false) {
        if (this.isPlay === false) {
          this.handleClickFull(2);
          this.showTitle = false;
        } else {
          this.isOpenFolder = false;
          this.handleStopPlay();
          this.showTitle = false;
          this.handleClickFull(2);
        }
      } else {
        if (this.isPlay === true) {
          this.isOpenFolder = false;
          this.showTitle = true;
          this.handleStopPlay();
        } else {
          this.handleClickFull(2);
          this.showTitle = false;
        }
      }
      //this.showTitle = !this.showTitle;
    },
    handleAnimation(animationText) {
      //console.log("animationText", animationText);
      let domImg = document.getElementById("image_id");
      domImg.className = "image_class";
      this.animationChecked = animationText.value;
      this.animationCheckedLabel = animationText.label;
      let animation = this.animationChecked;
      if (this.animationChecked == "imgRandom") {
        const animationList = [
          "imgZoomin",
          "imgZoominandOut",
          "imgScanLeft",
          "imgScanRight",
          "imgScrolldown",
          "imgScrolldownUp",
        ];
        const randomInt = Math.floor(Math.random() * 6);
        animation = animationList[randomInt];
      }
      setTimeout(() => {
        domImg.className = "image_class " + animation;
      }, 10);
      this.imgUrl[this.clickIndex].animation = this.animationChecked;
    },
    animationStart() {
      this.endConfig.animate = false;
      this.animationList.filter((item, index) => {
        if (item == this.animation) {
          this.animationIndex = (index + 1) % 4;
        }
      });
    },
    animationEnd() {
      const cycleAnimation = this.clickUrl.cycleanimation === 1 ? true : false;
      this.animation = this.animationList[this.animationIndex];
      this.endConfig.animate = true;
      //console.log("动画结束");
      if (this.callToActionEnable === 1) this.lastPageStopPlay();
      if (cycleAnimation && this.isPlay == true) {
        this.animationTimeOut = setTimeout(() => {
          let domImg = document.getElementById("image_id");
          domImg.className = "image_class";
          setTimeout(() => {
            domImg.className = "image_class " + this.animation;
          }, 10);
        }, 5000);
      }
    },
    animationPause() {
      if (this.clickUrl?.animation !== "") {
        let domImg = document.getElementById("image_id");
        domImg.style.animationPlayState = "paused";
        this.endConfig.animate = true;
        this.lastPageStopPlay();
      }
    },
    controlVideoToPlay(video) {
      clearTimeout(this.time);
      video.removeEventListener("timeupdate", this.timeupdatecb);
      video.removeEventListener("ended", this.handleAutoNext);
      if (this.audioScript) {
        this.audioScript.pause();
      }
      //console.log(this.audioScript);
      video.load();
      video.muted = this.clickUrl.mute === 1 ? true : false;
      let index = 0;
      let speakIndex = 0;
      let audioTime = "";
      this.speechText = [];
      if (this.clickUrl.videoSpeakText.length > 0) {
        video.muted = true;
        this.speechIndex = 0;
        this.videoScriptStart = this.clickUrl.videoSpeakText[0].start;
        this.clickUrl.videoSpeakText.filter((item) => {
          this.speechText.push(item.text);
        });
      }
      if (
        this.clickUrl.videoStartTime >= 0 &&
        this.clickUrl.videoStartTime !== null
      ) {
        video.currentTime = this.clickUrl.videoStartTime;
      }
      if (this.commandFull === 2) video.autoplay = true;
      this.timeupdatecb = () => {
        clearTimeout(this.time);
        if (
          this.clickUrl.videoEndTime >= 0 &&
          this.clickUrl.videoEndTime !== null &&
          video.currentTime >= this.clickUrl.videoEndTime
        ) {
          this.time = setTimeout(() => {
            video.pause();
            if (this.audioScript) {
              this.audioScript.pause();
            }
            this.handleAutoNext();
          }, 200);
          video.removeEventListener("timeupdate", this.timeupdatecb);
        }
        if (
          this.videoScriptStart >= 0 &&
          video.currentTime >= this.videoScriptStart &&
          index === 0 &&
          this.clickUrl.videoSpeakText[speakIndex]
        ) {
          this.time = setTimeout(() => {
            index = 1;
            this.speechIndex = speakIndex;
            const blob = new Blob(
              [
                new Uint8Array(
                  this.clickUrl.videoSpeakText[speakIndex].buffers
                ),
              ],
              {
                type: "audio/mp3",
              }
            );
            // this.audio.pause();
            this.audioScript = new Audio();
            this.audioScript.src = URL.createObjectURL(blob);
            this.audioScript.currentTime = 0;
            setTimeout(() => {
              this.audioScript.play();
            }, 200);

            this.audioScript?.addEventListener("play", () => {
              if (this.isPlay === false && this.audioScript) {
                this.audioScript.pause();
              }
            });
            this.audioScript?.addEventListener("ended", () => {
              clearTimeout(audioTime);
              audioTime = setTimeout(() => {
                speakIndex++;
                index = 0;
                this.videoScriptStart =
                  this.clickUrl.videoSpeakText[speakIndex]?.start;
              }, 200);
            });
          }, 200);
        }
      };
      if (this.commandFull === 2 && this.clickUrl.videoEndTime !== null)
        video.addEventListener("timeupdate", this.timeupdatecb);
      else if (this.commandFull === 2 && this.clickUrl.videoEndTime == null) {
        video.addEventListener("ended", this.handleAutoNext);
      }
    },
    getPreloadVideoScript(videoText) {
      if (videoText.videoSpeakText?.length > 0) {
        let bufferList = [];
        const textEncoder = new TextEncoder();
        const binaryHeadEnd = textEncoder.encode("Path:audio\r\n").toString();
        // this.currentTTSText = [-1, 0];
        // let currentTTSIndex = 0;
        return new Promise((resolve, reject) => {
          const requestId = this.guid();
          const ws = new WebSocket(
            "wss://speech.platform.bing.com/consumer/speech/synthesize/readaloud/edge/v1?TrustedClientToken=6A5AA1D4EAFF4E9FB37E23D68491D6F4"
          );
          ws.addEventListener("open", () => {
            ws.send(this.speechConfig());
            try {
              sendTTSText();
            } catch (e) {}
          });
          const sendTTSText = () => {
            if (!ws) return;
            if (
              this.currentTTSVideoText[0] ===
              videoText.videoSpeakText.length - 1
            ) {
              ws.close(1000);
              return;
            }
            if (this.currentTTSVideoIndex == 1) {
              resolve();
            }
            this.currentTTSVideoText[0] += 1;
            this.currentTTSVideoIndex++;
            // this.currentTTSText += 1
            const requestId = this.guid();
            //console.log("this.imgUrl[this.currentTTSText[0]]", this.currentTTSText);
            if (videoText.videoSpeakText[this.currentTTSVideoText[0]]) {
              videoText.videoSpeakText[this.currentTTSVideoText[0]].buffers =
                [];
              let textWord =
                videoText.videoSpeakText[this.currentTTSVideoText[0]].text;
              textWord = textWord
                .replaceAll("<", "")
                .replaceAll(">", "")
                .replaceAll("&", "and")
                .replaceAll(/[\^@#*]/gi, "");
              ws.send(
                this.ssmlText({
                  requestId,
                  text: textWord,
                  //lan: this.selectLang,
                  voiceName: this.selectVoices,
                  pitch: "+10",
                  rate: "+" + this.rate,
                })
              );
            }
          };

          ws.addEventListener("message", async ({ data }, ...arg) => {
            // console.log("prop---------", arg);
            if (data instanceof Blob) {
              const view = new Uint8Array(await data.arrayBuffer());
              bufferList.push(
                ...view
                  .toString()
                  .split(binaryHeadEnd)[1]
                  .split(",")
                  .slice(1)
                  .map((i) => +i)
              );
              if (view[0] == 0x00 && view[1] == 0x67 && view[2] == 0x58) {
                if (videoText.videoSpeakText[this.currentTTSVideoText[0]])
                  videoText.videoSpeakText[
                    this.currentTTSVideoText[0]
                  ].buffers = bufferList;
                bufferList = [];
                sendTTSText();
                // ws.close(1000);
              }
            }
          });
          ws.addEventListener("error", (err) => {
            console.log("------出错了", err);
            // reject(err);
            this.getPreloadVideoScript(videoText)
              .then((res) => resolve(res))
              .catch((error) => reject(error));
          });
          ws.addEventListener("close", (event) => {
            if (event.code != 1000 && event.code != 1006) {
              console.error("----关闭了", event);
              reject(event.code);
              return;
            }
            // const blob = new Blob([new Uint8Array(bufferList)], {
            //   type: "audio/mjpeg",
            // });
            // resolve(URL.createObjectURL(blob));
            resolve();
          });
        });
      }
    },
    speakAudio() {
      //console.log(this.speechIndex, this.speechText.length);
      if (this.speechIndex < this.speechText.length - 1) {
        this.speechIndex++;
        this.speak(this.imgUrl.scripts[0] ? this.imgUrl.scripts[0] : "");
      } else if (this.blogBrief) {
        this.handleStopPlay(2);
        //此时脚本读完展示end info
        if (this.callToActionEnable === 1) this.checkShowEndData();
      }
    },
    speakAudioScript() {
      // console.log(111111, this.imgUrl);
      this.speechIndex = 0;
      this.speechText = this.imgUrl.scripts.filter((item) => {
        return item.length > 0;
      });
      this.speak(this.imgUrl.scripts[0] ? this.imgUrl.scripts[0] : "");
      this.handleSetInterval(this.autoPlaySlide * 1000);
    },
    /* end info */
    resetEndConfig() {
      for (const key in this.endConfig) {
        this.endConfig[key] = false;
      }
    },
    closeEndData() {
      this.showEndData = false;
      // console.log("关闭");
    },
    closeTimerToShowEndData() {
      if (this.endTimer) {
        clearTimeout(this.endTimer);
        this.showEndData = true;
      }
    },
    startTimerToShowEndData(ms = 20000) {
      this.showEndData = true;
      this.endTimer = setTimeout(() => {
        clearTimeout(this.endTimer);
        this.reloadPPT();
      }, ms);
    },
    stopTimer() {
      if (this.endTimer) {
        clearTimeout(this.endTimer);
        this.showEndData = false;
      }
    },
    reloadPPT() {
      this.clickIndex = 0;
      this.clickUrl = this.imgUrl[this.clickIndex];
      //console.log("iiii", this.commandFull);
      // if (this.blogBrief || this.playMode === "chat") {
      //   this.handleClickFull();
      // } else {
      //   this.handleClickFull(this.commandFull);
      // }
      this.handleClickFull(this.commandFull);
      this.closeEndData();
    },
    sharePPT() {
      navigator.clipboard.writeText(location.href);
      this.$message.success(cI18n("presentation.end.copyNotify"));
    },
    lastPageStopPlay() {
      if (this.clickIndex === this.imgUrl.length - 1) {
        this.handleStopPlay(this.commandFull);
        this.checkShowEndData();
      }
    },
    checkShowEndData() {
      if (
        this.checkValidAnimation() &&
        this.commandFull === 2 &&
        this.clickUrl.speakTest
      ) {
        if (this.endConfig.animate) {
          this.stopTimer();
          this.startTimerToShowEndData();
        }
      } else if (this.checkValidAnimation() && this.commandFull !== 2) {
        if (this.endConfig.animate) {
          this.stopTimer();
          this.startTimerToShowEndData();
        }
      } else if (this.commandFull === 1 && !this.checkValidAnimation()) {
        this.stopTimer();
        this.startTimerToShowEndData();
      } else {
        this.stopTimer();
        this.startTimerToShowEndData();
      }
    },
    checkValidAnimation() {
      return (
        this.clickUrl?.animation !== "" &&
        this.clickUrl?.animation !== null &&
        this.clickUrl?.animation !== undefined
      );
    },
    checkIsVideo() {
      const url = this.imgUrl[this.clickIndex].url;
      return [
        "mov",
        "mp4",
        "avi",
        "flv",
        "3gp",
        "webm",
        "rmvb",
        "wmv",
        "asf",
        "asx",
        "vob",
        "dat",
        "mkv",
      ].includes(url.split(".")[url.split(".").length - 1].toLowerCase());
    },
  },
  mounted() {
    if (
      location.origin.includes("sflow.pro") ||
      location.origin.includes("saasflow.cn")
    ) {
      this.chineseWebsite = true;
    }
    this.loadingIntance = this.$loading({
      fullscreen: true,
      text: this.chineseWebsite ? "加载中" : "loading",
      customClass: "chat-loading",
    });
    document.addEventListener("fullscreenchange", (e) => {
      let isFullScreen = document.fullscreenElement;
      if (!isFullScreen) {
        this.isFull = true;
      } else {
        this.isFull = false;
      }
    });
    // console.log("window.location.search", window.location.search)
    const urlSearch = window.location.search;
    if (urlSearch && typeof urlSearch === "string" && urlSearch.length > 2) {
      const searchText = urlSearch.slice(1);
      const paramsArr = searchText.split("&");
      const paramsObj = {};
      paramsArr.forEach((param) => {
        if (typeof param === "string" && param.indexOf("=")) {
          const paramArr = param.split("=");
          paramsObj[paramArr[0]] = paramArr[1];
        }
      });
      // const presentationId = "c76298e0-cdd1-11ed-88d5-85abc71551bc"
      if (paramsObj.blogContent === "local") {
        this.blogContentMode = "local";
      }
      const presentationId = paramsObj.s;
      this.shareUUID = presentationId;
      const presentationShort = paramsObj.l;
      if (presentationId) {
        if (presentationId.includes("blog")) {
          this.playMode = "blog";
          this.watchBlogData();
          if (paramsObj.i) {
            // 直接通过 blogId 获取数据
            this.getBlogDetailByBlogId(paramsObj.i);
          }
        } else if (presentationId.includes("brief")) {
          this.playMode = "brief";
          this.watchBlogData();
          if (paramsObj.i) {
            // 直接通过 blogId 获取数据
            this.getBlogDetailByBlogId(paramsObj.i);
          }
        } else if (presentationShort) {
          if (presentationShort.includes("short")) {
            this.playMode = "short";
            this.init(presentationId);
            //console.log("this.playMode--------------", this.playMode);
          }
        } else if (presentationId.includes("issue")) {
          this.playMode = "issue";
          this.watchBlogData();
          const issueIdBase64 = paramsObj.is;
          if (issueIdBase64) {
            this.playMode = "issue";
            this.getIssueDetail(issueIdBase64);
          }
        } else if (presentationId.includes("chat")) {
          this.playMode = "chat";
          this.watchBlogData();
        } else {
          this.init(presentationId);
          // 开启来自blog页面的监听
          this.watchBlogData();
        }
      }
    }
  },
  watch: {
    clickIndex(newValue, oldValue) {
      // console.log(newValue, this.imgUrl.length - 1);
      clearTimeout(this.animationTimeOut);
      this.updatePDR(newValue + 1);
      if (newValue === this.imgUrl.length - 1) {
        if (
          !(
            this.commandFull === 2 &&
            (this.checkIsVideo() ||
              this.clickUrl.speakTest ||
              this.clickUrl.scriptAudio)
          ) &&
          !this.blogBrief
        ) {
          if (this.callToActionEnable === 1) this.lastPageStopPlay();
        }
        //this.lastPageStopPlay();
      }

      let domImg = document.getElementById("image_id");
      if (domImg) domImg.className = "image_class";
      let animation =
        this.imgUrl[this.clickIndex] &&
        this.imgUrl[this.clickIndex].animation !== null
          ? this.imgUrl[this.clickIndex].animation
          : "";
      if (this.playMode === "blog") {
        animation =
          this.imgUrl[this.clickIndex] &&
          this.imgUrl[this.clickIndex].animation !== null
            ? this.imgUrl[this.clickIndex].animation
            : "imgRandom";
      }
      this.animation = animation;
      this.animationChecked = this.animation;
      this.animationOption.filter((item) => {
        if (item.value == this.animation)
          this.animationCheckedLabel = item.label;
      });
      if (animation) {
        if (animation == "imgRandom") {
          const animationList = [
            "imgZoomin",
            "imgZoominandOut",
            "imgScanLeft",
            "imgScanRight",
            "imgScrolldown",
            "imgScrolldownUp",
          ];
          const randomInt = Math.floor(Math.random() * 6);
          animation = animationList[randomInt];
          this.animation = animation;
        }
        setTimeout(() => {
          domImg.className = "image_class " + animation;
        }, 10);
      }

      let iframeClass = document.getElementsByClassName("iframe_class");
      if (iframeClass) {
        for (let iframe of iframeClass) {
          if (
            iframe.src == this.clickUrl.url ||
            iframe.src.slice(0, iframe.src.length - 1) == this.clickUrl.url
          ) {
            iframe.style.visibility = "visible";
            this.postIframeScrollMsg(iframe, this.imgUrl[newValue].id);
            setTimeout(() => {
              this.postGetBlogScrollData(iframe);
            }, 1000 * 1);
          } else {
            iframe.style.visibility = "hidden";
          }
        }
      }
      // console.log("click ininininin", this.imgUrl[newValue])
      if (
        this.defaultImgUrl.length > 1 &&
        this.defaultImgUrl[1].url.length === 0
      ) {
        this.isDefault = true;
        this.defaultImgUrl = this.imgUrl;
      }
      // let domOldValue = document.getElementById("drag_left_" + oldValue);
      // if (domOldValue) {
      //   domOldValue.style.border = "none";
      // }
      // let domLeftIndex = document.getElementById(
      //   "drag_left_" + this.clickIndex
      // );
      // if (domLeftIndex) {
      //   domLeftIndex.style.border = "2px solid red";
      // }
    },
    imgUrl: {
      handler(nv, ov) {
        if (nv.length === 1 && this.clickIndex === 0) {
          const timer = setTimeout(() => {
            this.lastPageStopPlay();
            clearTimeout(timer);
          }, 2000);
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style scoped>
.video-canvas {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.drag_class {
  width: 160px;
  height: 100px;
  overflow: hidden;
  margin-bottom: 10px;
  align-content: center;
  cursor: pointer;
  background-color: #5077d3;
  opacity: 1;
}
.drag_border {
  border: 2px solid red;
}
.class_list {
  width: 180px;
  height: 100%;
  position: absolute;
  top: 0;
  overflow-x: hidden;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 10;
}
.footer {
  width: 100%;
  height: 50px;
  background: rgba(0, 0, 0, 0.7);
  position: relative;
  top: -50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 100;
}
.auto_class {
  width: 100%;
  height: 24px;
  line-height: 24px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
}
.tool_class {
  color: #999999;
}
.play_mode {
  position: absolute;
  left: 175px;
  text-align: center;
}
.icon_left_class {
  margin-right: 13vh;
}
.language_class {
  position: absolute;
  right: 191px;
}
.setting_class {
  position: absolute;
  right: 120px;
}
.fullscreen_class {
  position: absolute;
  right: 50px;
}
.icon_class {
  text-align: center;
  padding: 0;
  width: 26px;
  height: 26px;
  line-height: 26px;
  z-index: 10;
  font-size: 20px;
  cursor: pointer;
  /* border: 1px solid #f3f3f3;
  border-radius: 50%; */
  color: #f3f3f3;
}
.free {
  width: 150px;
  height: 40px;
  background: #2b5aff;
  border-radius: 20px;
  font-size: 16px;
  text-align: center;
  color: #fff;
  line-height: 40px;
  position: absolute;
  right: 50px;
  top: 40px;
  cursor: pointer;
}
.icon_folder {
  cursor: pointer;
  position: absolute;
  left: 50px;
}
.video-content {
  width: 100%;
  height: 100%;
  /* min-height: 500px; */
}
.close_caption {
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  min-height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  bottom: 50px;
  transform: translateX(-50%);
  font-size: 18px;
}
.hidden_text {
  width: 100%;
  height: auto;
  max-height: 45px;
  font-size: 10px;
  overflow-wrap: anywhere;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.voice_class {
  position: absolute;
  left: 120px;
  cursor: pointer;
}
.video-title {
  height: 6vh;
  min-height: 30px;
  max-width: 100%;
  font-size: max(3vh, 16px);
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 3%;
  top: 5%;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: max(3vh, 15px);
}
.imgZoomin {
  -webkit-animation: zoomIn 10s linear 1;
  animation: zoomIn 10s linear 1;
  transform: scale(2);
}

@-webkit-keyframes zoomIn {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(2);
  }
}
@keyframes zoomIn {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(2);
  }
}
.imgZoominandOut {
  -webkit-animation: zoomInandOut 10s linear 1;
  animation: zoomInandOut 10s linear 1;
  transform: scale(1);
}
@-webkit-keyframes zoomInandOut {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(2);
  }
}
@keyframes zoomInandOut {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(2);
  }
}
.imgScanLeft {
  -webkit-animation: scanLeft 20s linear 1;
  animation: scanLeft 20s linear 1;
  transform: scale(1);
}
@-webkit-keyframes scanLeft {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(2) translateX(25%);
  }
  50% {
    transform: scale(2) translateX(0);
  }
  75% {
    transform: scale(2) translateX(-25%);
  }
}
@keyframes scanLeft {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(2) translateX(25%);
  }
  50% {
    transform: scale(2) translateX(0);
  }
  75% {
    transform: scale(2) translateX(-25%);
  }
}
.imgScanRight {
  -webkit-animation: scanRight 20s linear 1;
  animation: scanRight 20s linear 1;
  transform: scale(1);
}
@-webkit-keyframes scanRight {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(2) translateX(-25%);
  }
  50% {
    transform: scale(2) translateX(0);
  }
  75% {
    transform: scale(2) translateX(25%);
  }
}
@keyframes scanRight {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(2) translateX(-25%);
  }
  50% {
    transform: scale(2) translateX(0);
  }
  75% {
    transform: scale(2) translateX(25%);
  }
}
.imgScrolldown {
  -webkit-animation: scrolldown 20s linear 1;
  animation: scrolldown 20s linear 1;
  transform: scale(1);
}
@-webkit-keyframes scrolldown {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(2) translateY(25%);
  }
  50% {
    transform: scale(2) translateY(0);
  }
  75% {
    transform: scale(2) translateY(-25%);
  }
}
@keyframes scrolldown {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(2) translateY(25%);
  }
  50% {
    transform: scale(2) translateY(0);
  }
  75% {
    transform: scale(2) translateY(-25%);
  }
}
.imgScrolldownUp {
  -webkit-animation: scrolldownUp 20s linear 1;
  animation: scrolldownUp 20s linear 1;
  transform: scale(1);
}
@-webkit-keyframes scrolldownUp {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(2) translateY(25%);
  }
  40% {
    transform: scale(2) translateY(0);
  }
  60% {
    transform: scale(2) translateY(-25%);
  }
  80% {
    transform: scale(2) translateY(25%);
  }
}
@keyframes scrolldownUp {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(2) translateY(25%);
  }
  40% {
    transform: scale(2) translateY(0);
  }
  60% {
    transform: scale(2) translateY(-25%);
  }
  80% {
    transform: scale(2) translateY(25%);
  }
}
@media (min-width: 1024px) {
  .play_icon_text {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -7vh;
    margin-top: -7vh;
    display: inline-block;
    border-radius: 50%;
    height: 14vh;
    width: 14vh;
    cursor: pointer;
  }
}
@media (min-width: 760px) and (max-width: 1024px) {
  .play_icon_text {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -7vh;
    margin-top: -7vh;
    display: inline-block;
    border-radius: 50%;
    height: 14vh;
    width: 14vh;
    cursor: pointer;
  }
}
@media (max-width: 760px) {
  .play_icon_text {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -5.5vh;
    margin-top: -5.5vh;
    display: inline-block;
    border-radius: 50%;
    height: 11vh;
    width: 11vh;
    cursor: pointer;
  }
  .icon_folder {
    left: 0;
  }
  .play_mode {
    left: 17vw;
  }
  .icon_left_class {
    margin-right: 5vw;
  }
  .language_class {
    right: 20vw;
  }
  .setting_class {
    right: 10vw;
  }
  .fullscreen_class {
    right: 0;
  }
  .free {
    right: 0;
  }
  .voice_class {
    left: 8vw;
  }
}
.play-menu-item {
  font-family: Arial, Helvetica, sans-serif;
}
</style>
<style>
.pop_class.el-popover {
  background: rgba(0, 0, 0, 0.7);
  border: none;
  min-width: 30px;
}
.pop_class.el-popover.el-popper[x-placement^="top"] .popper__arrow::after {
  border-top-color: #000000;
  opacity: 0.7;
}
.pop_class.el-popover.el-popper[x-placement^="top"] .popper__arrow {
  border-top-color: #000000;
  opacity: 0.7;
}
.pop_class.el-popover.el-popper[x-placement^="top-end"] .popper__arrow::after {
  border-top-color: #000000;
  opacity: 0.7;
}
.pop_class.el-popover.el-popper[x-placement^="top-end"] .popper__arrow {
  border-top-color: #000000;
  opacity: 0.7;
}
.pop_class.el-popover.el-popper[x-placement^="right-start"]
  .popper__arrow::after {
  border-right-color: #000000;
  opacity: 0.7;
}
.pop_class.el-popover.el-popper[x-placement^="right-start"] .popper__arrow {
  border-right-color: #000000;
  opacity: 0.7;
}
.slider_class.el-slider.is-vertical .el-slider__runway {
  width: 4px;
  background-color: #666666;
}
.slider_class.el-slider.is-vertical .el-slider__button {
  width: 10px;
  height: 10px;
  border: none;
  transform: translateX(-1px);
}
.slider_class.el-slider.is-vertical .el-slider__bar {
  width: 4px;
  background-color: #fff;
}
.menuitem-hover:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 5px;
}
</style>
